<template>
  <div class="report_container">
    <div class="searchBox Cf">
      <el-tabs
        v-model="activeName"
        class="common-marginBottomRight10"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="今天"
          :disabled="isDisabled"
          name="today"
        ></el-tab-pane>
        <el-tab-pane
          label="昨天"
          :disabled="isDisabled"
          name="yesterday"
        ></el-tab-pane>
        <el-tab-pane
          label="近三天"
          :disabled="isDisabled"
          name="threedays"
        ></el-tab-pane>
        <el-tab-pane
          label="本周"
          :disabled="isDisabled"
          name="week"
        ></el-tab-pane>
        <el-tab-pane
          label="上周"
          :disabled="isDisabled"
          name="lastweek"
        ></el-tab-pane>
        <el-tab-pane
          label="本月"
          :disabled="isDisabled"
          name="mouth"
        ></el-tab-pane>
        <el-tab-pane
          label="上月"
          :disabled="isDisabled"
          name="lastmouth"
        ></el-tab-pane>
        <el-tab-pane
          label="选择旬"
          :disabled="isDisabled"
          name="xun"
        ></el-tab-pane>
      </el-tabs>
      <!-- 选择旬 -->
      <div class="time-box" v-if="showXunSelect">
        <div class="common-marginBottomRight10">
          <span class="time-text" style="margin-right: 10px">选择年</span>
          <el-date-picker
            v-model="defaultYear"
            type="year"
            placeholder="选择年"
            size="mini"
            style="width: 100px"
            format="yyyy"
            value-format="yyyy"
            @change="
              (value) => {
                handleSelectYear(0, value);
              }
            "
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div class="common-marginBottomRight10">
          <span class="time-text" style="margin-right: 10px">选择月</span>
          <el-date-picker
            v-model="defaultMonth"
            :clearable="false"
            type="month"
            placeholder="选择月"
            size="mini"
            style="width: 100px"
            format="MM"
            value-format="MM"
            @change="
              (source) => {
                handleSelectMonth(0);
              }
            "
          >
          </el-date-picker>
        </div>
        <!-- <div class="time-text">输入年份：</div>
        <el-input
          v-model.number="form.year"
          @change="
            (value) => {
              handleIsNumber(0, 1, value);
            }
          "
          placeholder="输入年份"
          size="mini"
          class="date_input common-marginBottomRight10"
          :validate-event="true"
        >
          ></el-input
        > -->
      </div>
      <!-- <div class="time-box" v-if="showXunSelect">
        <div class="time-text">输入月份：</div>
        <el-input
          v-model.number="form.month"
          placeholder="输入月份"
          @change="
            (value) => {
              handleIsNumber(0, 2, value);
            }
          "
          size="mini"
          class="date_input common-marginBottomRight10"
        ></el-input>
      </div> -->
      <el-tabs
        class="common-marginBottomRight10"
        type="card"
        @tab-click="handleSelectXun"
        v-if="showXunSelect"
        v-model="xunValue"
      >
        <el-tab-pane label="上旬" name="first"> </el-tab-pane>
        <el-tab-pane label="中旬" name="middle"> </el-tab-pane>
        <el-tab-pane label="下旬" name="end"> </el-tab-pane>
      </el-tabs>

      <!-- 选择一段时间 -->
      <div class="time-box" v-if="showTimeSelect">
        <div class="time-text">选择时间段：</div>
        <el-date-picker
          v-model="dateValue"
          class="common-marginBottomRight10"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '23:59:59']"
          :disabled="isDisabled"
          style="margin-left: 10px"
          @change="onDateRangeChange"
          value-format="timestamp"
          align="left"
          size="mini"
        >
        </el-date-picker>
      </div>
      <el-switch
        v-model="switchValue"
        active-text="已开口"
        :disabled="isDisabled"
        inactive-text="全部"
        class="common-marginBottomRight10 switchSize"
        @change="stateChange"
        style="white-space: nowrap"
      ></el-switch>
      <el-select
        v-model="sourceValue"
        @change="sourceChange"
        size="mini"
        placeholder="请选择搜索渠道"
        clearable
        :disabled="isDisabled"
        class="common-marginBottomRight10"
      >
        <el-option
          v-for="(item, index) in sourceMap"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <!-- 搜索范围 -->
      <el-select
        v-model="keyrange"
        @change="changeSearchScope"
        size="mini"
        placeholder="请选择搜索范围"
        clearable
        :disabled="isDisabled"
        class="common-marginBottomRight10"
      >
        <el-option
          v-for="(value, key, index) in searchScopeData"
          :key="index"
          :label="value"
          :value="key"
        >
        </el-option>
      </el-select>
      <!-- 搜索框 -->
      <el-input
        size="mini"
        :disabled="isDisabled"
        v-model="searchInput"
        maxlength="120"
        placeholder="请先选择搜索范围"
        class="input-with-select common-marginBottomRight10"
        clearable
        @clear="clearAction()"
      >
        <!-- @input="putChange" -->
        <el-button
          slot="append"
          icon="el-icon-search"
          :disabled="isDisabled"
          @click="searchAll"
        ></el-button>
      </el-input>
    </div>

    <!-- 特殊按钮 -->
    <div
      style="
        margin: 0 auto 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 96%;
      "
    >
      <el-button type="danger" size="mini" @click="resetAction">重置</el-button>
      <el-button
        type="primary"
        @click="clickConfig"
        size="mini"
        style="margin-left: 10px"
        >配置选项</el-button
      >
      <el-button
        v-if="$store.state.authority.isDownHtml == false"
        style="margin-left: 10px"
        size="mini"
        type="warning"
        @click="exportToExcel(1)"
        >导出报表</el-button
      >
      <el-dropdown v-else style="margin-left: 10px">
        <el-button type="warning" size="mini">
          导出报表<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="exportToExcel(1)"
            >Excel报表</el-dropdown-item
          >
          <el-dropdown-item @click.native="exportToCsv"
            >csv报表</el-dropdown-item
          >
          <el-dropdown-item @click.native="exportToHtml(0)"
            >Html报表</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        type="success"
        size="mini"
        @click="showCount"
        style="margin-left: 10px"
        >客服统计</el-button
      >
      <el-button
        type="primary"
        size="mini"
        @click="batchTagDialog"
        style="margin-left: 10px"
        >批量打标签</el-button
      >
      <el-button
        type="warning"
        size="mini"
        :disabled="selectedRows.length === 0"
        style="margin-left: 10px"
        @click="blockVisitors"
        >屏蔽访客</el-button
      >
      <el-radio-group v-model="tableDisplayMode" size="mini" style="margin-left: 16px">
        <el-radio-button label="record">
          <i class="el-icon-refresh" style="margin-right: 4px"></i>记录模式
        </el-radio-button>
        <el-radio-button label="group">
          <i class="el-icon-s-operation" style="margin-right: 4px"></i>分组模式
        </el-radio-button>
      </el-radio-group>
    </div>
    <!-- 汇总专区 -->
    <div class="summary-zone">
      <div class="summary-zone-title">
        <span class="summary-zone-title-text">数据汇总</span>
      </div>
      <div class="summary-zone-content">
        <!-- 分区一：总计 -->
        <div class="summary-part summary-part-total">
          <div class="summary-part-header">总计</div>
          <div class="summary-part-body">
            <div class="summary-row">
              <div class="summary-item">
                <span class="summary-label">总浏览数</span>
                <span class="summary-value">{{ llcount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总对话率</span>
                <span class="summary-value">{{ diaRate }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总对话数</span>
                <span class="summary-value">{{ ddcount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总转潜数</span>
                <span class="summary-value">{{ wxcount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总转潜率</span>
                <span class="summary-value">{{ wxRate }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总浏览转潜率</span>
                <span class="summary-value">{{ zhuanqianBrowseRate }}</span>
              </div>
            </div>
            <!-- <div class="summary-row summary-row-extra">
              <div class="summary-item">
                <span class="summary-label">总一句话对话数量</span>
                <span class="summary-value">{{ oneSentenceCount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总一句话对话占比</span>
                <span class="summary-value">{{ oneSentenceRate }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总三句话以内对话数量</span>
                <span class="summary-value">{{ threeSentenceCount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">总三句话以内对话占比</span>
                <span class="summary-value">{{ threeSentenceRate }}</span>
              </div>
            </div> -->
          </div>
        </div>
        <!-- 分区二：当前筛选 -->
        <div class="summary-part summary-part-filter">
          <div class="summary-part-header">当前筛选</div>
          <div class="summary-part-body">
            <div class="summary-row">
              <div class="summary-item">
                <span class="summary-label">浏览数</span>
                <span class="summary-value">{{ dgTableCountObj.llcount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">对话率</span>
                <span class="summary-value">{{ dgTableCountObj.diaRate }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">对话数</span>
                <span class="summary-value">{{ dgTableCountObj.ddcount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">转潜数</span>
                <span class="summary-value">{{ dgTableCountObj.wxcount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">转潜率</span>
                <span class="summary-value">{{ dgTableCountObj.wxRate }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">浏览转潜率</span>
                <span class="summary-value">{{ dgTableCountObj.zhuanqianBrowseRate }}</span>
              </div>
            </div>
            <!-- <div class="summary-row summary-row-extra">
              <div class="summary-item">
                <span class="summary-label">一句话对话数量</span>
                <span class="summary-value">{{ dgTableCountObj.oneSentenceCount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">一句话对话占比</span>
                <span class="summary-value">{{ dgTableCountObj.oneSentenceRate }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">三句话以内对话数量</span>
                <span class="summary-value">{{ dgTableCountObj.threeSentenceCount }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">三句话以内对话占比</span>
                <span class="summary-value">{{ dgTableCountObj.threeSentenceRate }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- v-load-more="{ target: '.el-table__body-wrapper' }" -->
    <div class="tb_div">
      <dg-table
        ref="dgTable"
        v-if="isShowTb === true"
        :data="displayTableData"
        :group-span-info="groupSpanInfo"
        :selection="true"
        :pagination="true"
        :source="selectForm.source"
        :keyrange="keyrange"
        v-load-more="{ target: '.el-table__body-wrapper' }"
        :page-config="{
          pagenum: pagenum,
          curpage: curpage,
          pagesize: pagesize,
        }"
        :filter-init="[]"
        :column-config="config"
        @filter-change="getFilter"
        @select-change="handleSelectionChange"
        @page-change="getpage"
        @filterOption="statisticsColumn"
        :isloading="tbLoading"
        @size-change="getsize"
        @order-change="orderChange"
        @filter-date="getDateFilter"
        :columnsList="columnList"
        @delTag="deleteFilter"
        @row-dblclick="onclick"
        :highlight-current-row="true"
        :countRate="dgTableCountObj"
        @row-contextmenu="rightClick"
      ></dg-table>
    </div>
    <chat-drawer
      :isShow="showDetail"
      @closeDial="closeDialAction"
      :item="cellItem"
      @tagChanged="tagChangeAction"
      @updateNickname="updateNickname"
      @updateMark="updateMark"
    >
    </chat-drawer>

    <!-- 批量打标签对话框 -->
    <el-dialog
      title="批量打标签"
      :visible.sync="batchTagDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="!isProcessing"
    >
      <div class="batch-tag-content">
        <div class="selected-info">
          <p>已选择 <span class="selected-count">{{ selectedRows.length }}</span> 条会话记录</p>
          <p class="selected-tip">请在主列表中选择要打标签的会话记录</p>
        </div>
        
        <div class="tag-section" v-if="!isProcessing">
          <div class="common-tags" v-if="usedTagList.length > 0">
            <label class="tag-label">常用标签</label>
            <div class="tag-container">
              <div
                v-for="(item, index) in usedTagList"
                :key="index"
                @click="toggleTag(0, index)"
                class="tag-item"
              >
                <div class="tag-btn" v-if="!item.selected">{{ item.name }}</div>
                <div
                  v-else
                  class="tag-selected"
                  :style="{
                    'border-color': '#' + item.color,
                    color: '#' + item.color,
                  }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          
          <div class="all-tags">
            <label class="tag-label">所有标签</label>
            <div class="tag-container">
              <div
                v-for="(item, index) in allTagList"
                :key="index"
                @click="toggleTag(1, index)"
                class="tag-item"
              >
                <div class="tag-btn" v-if="!item.selected">{{ item.name }}</div>
                <div
                  v-else
                  class="tag-selected"
                  :style="{
                    'border-color': '#' + item.color,
                    color: '#' + item.color,
                  }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 进度条 -->
        <div class="progress-section" v-if="isProcessing">
          <el-progress 
            :percentage="progressPercentage" 
            :status="progressStatus"
            :stroke-width="8"
          ></el-progress>
          <p class="progress-text">{{ progressText }}</p>
          <div class="progress-details">
            <p>成功: {{ successCount }} 条</p>
            <p>失败: {{ failCount }} 条</p>
            <p>总计: {{ selectedRows.length }} 条</p>
          </div>
        </div>

        <!-- 结果展示 -->
        <div class="result-section" v-if="showResult">
          <h4>处理结果</h4>
          <div class="result-summary">
            <p class="success-text">成功: {{ successCount }} 条</p>
            <p class="fail-text">失败: {{ failCount }} 条</p>
          </div>
          
          <div v-if="failList.length > 0" class="fail-details">
            <h5>失败记录:</h5>
            <el-table :data="failList" size="mini" max-height="200">
              <el-table-column prop="customer_nickname" label="用户昵称" width="120"></el-table-column>
              <el-table-column prop="createTime" label="时间" width="120"></el-table-column>
              <el-table-column prop="errorMsg" label="失败原因"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBatchTag" size="small" :disabled="isProcessing" v-if="!showResult">取 消</el-button>
        <el-button 
          type="primary" 
          @click="startBatchTag" 
          size="small"
          :disabled="isProcessing || selectedRows.length === 0 || getSelectedTags().length === 0"
          v-if="!isProcessing && !showResult"
        >
          开始打标签
        </el-button>
        <el-button 
          type="primary" 
          @click="closeBatchTagDialog" 
          size="small"
          v-if="showResult"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <div v-show="isShowConfig" class="dialog_div">
      <div class="back_div">
        <div class="title_div">{{ configText }}</div>
        <div class="diagBack">
          <el-transfer
            ref="transfer"
            id="transfer"
            v-model="value"
            :data="data"
            :titles="['可选配置', '已选配置']"
            target-order="push"
            @change="transferChange"
          >
            <!-- :class="[option.item.isSort === 0 ? 'no-drage' : 'draggable']" -->
            <!-- :draggable="option.item.isSort === 1" -->
            <span
              slot-scope="{ option }"
              @dragstart="dragStart($event, option)"
              style="display: inline-block; width: 100%"
              ><span style="padding-left: 24px"></span>{{ option.label }}
              <!-- <span style="color: red" v-show="option.item.isSort === 0"
                >(不可拖动)</span
              > -->
            </span>
          </el-transfer>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="isShowConfig = false">取 消</el-button>
          <el-button type="primary" @click="saveRequest">确 定</el-button>
        </div>
      </div>
    </div>
    <!-- 客服统计报表 -->
    <div class="csCount" v-show="showCsCount">
      <el-dialog
        title="客服统计表"
        width="98%"
        lock-scroll
        :visible.sync="showCsCount"
        @close="handleCsHide"
        :close-on-click-modal="false"
      >
        <template slot="title">
          <span class="el-dialog__title">客服统计表</span>
        </template>
        <!-- 客服  选择 时间查询 -->
        <div class="searchBox" style="width: 100%; margin-top: -6px">
          <el-tabs
            v-model="csActiveName"
            class="common-marginBottomRight10"
            type="card"
            @tab-click="handleCsClick"
          >
            <el-tab-pane
              label="今天"
              :disabled="csCountIsDisabled"
              name="csToday"
            ></el-tab-pane>
            <el-tab-pane
              label="昨天"
              :disabled="csCountIsDisabled"
              name="csYesterday"
            ></el-tab-pane>
            <el-tab-pane
              label="近三天"
              :disabled="csCountIsDisabled"
              name="csThreedays"
            ></el-tab-pane>
            <el-tab-pane
              label="本周"
              :disabled="csCountIsDisabled"
              name="csWeek"
            ></el-tab-pane>
            <el-tab-pane
              label="上周"
              :disabled="csCountIsDisabled"
              name="csLastweek"
            ></el-tab-pane>
            <el-tab-pane
              label="本月"
              :disabled="csCountIsDisabled"
              name="csMouth"
            ></el-tab-pane>
            <el-tab-pane
              label="上月"
              :disabled="csCountIsDisabled"
              name="csLastmouth"
            ></el-tab-pane>
            <el-tab-pane
              label="选择旬"
              :disabled="csCountIsDisabled"
              name="csXun"
            ></el-tab-pane>
          </el-tabs>
          <!-- 选择旬 -->
          <div class="time-box" v-if="csShowXunSelect">
            <div class="common-marginBottomRight10">
              <span class="time-text" style="margin-right: 10px">选择年</span>
              <el-date-picker
                v-model="csDefaultYear"
                type="year"
                placeholder="选择年"
                size="mini"
                style="width: 100px"
                format="yyyy"
                value-format="yyyy"
                @change="
                  (value) => {
                    handleSelectYear(1, value);
                  }
                "
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <div class="common-marginBottomRight10">
              <span class="time-text" style="margin-right: 10px">选择月</span>
              <el-date-picker
                v-model="csDefaultMonth"
                :clearable="false"
                type="month"
                placeholder="选择月"
                @change="
                  (value) => {
                    handleSelectMonth(1, value);
                  }
                "
                size="mini"
                style="width: 100px"
                format="MM"
                value-format="MM"
              >
              </el-date-picker>
            </div>
            <!-- <div class="time-text">输入年份：</div>
            <el-input
              v-model.number="csForm.year"
              placeholder="输入年份"
              @change="
                (value) => {
                  handleIsNumber(1, 1, value);
                }
              "
              size="mini"
              class="date_input common-marginBottomRight10"
            ></el-input> -->
          </div>
          <!-- <div class="time-box" v-if="csShowXunSelect">
            <div class="time-text">输入月份：</div>
            <el-input
              v-model.number="csForm.month"
              @change="
                (value) => {
                  handleIsNumber(1, 2, value);
                }
              "
              placeholder="输入月份"
              size="mini"
              class="date_input common-marginBottomRight10"
            ></el-input>
          </div> -->
          <el-tabs
            class="common-marginBottomRight10 csXunActive"
            type="card"
            @tab-click="csHandleSelectXun"
            v-if="csShowXunSelect"
            v-model="csXunValue"
          >
            <el-tab-pane label="上旬" class="abcde" name="first"></el-tab-pane>
            <el-tab-pane label="中旬" class="abcde" name="middle"></el-tab-pane>
            <el-tab-pane label="下旬" name="end"></el-tab-pane>
          </el-tabs>
          <!-- 选择一段时间 -->
          <div class="time-box" v-if="csShowTimeSelect">
            <div class="time-text">选择时间段：</div>
            <el-date-picker
              v-model="dateValue2"
              class="common-marginBottomRight10"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="margin-left: 10px"
              @change="
                (source) => {
                  selectDate2(999);
                }
              "
              value-format="timestamp"
              align="left"
              size="mini"
            >
            </el-date-picker>
          </div>
          <!-- 科室选择 -->

          <el-select
            v-model="officeValue"
            multiple
            placeholder="全部"
            class="csOffice common-marginBottomRight10"
            filterable
            size="mini"
            @change="handleCsSelectedOffice"
          >
            <el-option
              v-for="item in csOffice"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>

          <el-switch
            v-model="csSwitchValue"
            active-text="坐席接入"
            :disabled="csCountIsDisabled"
            inactive-text="全部"
            class="common-marginBottomRight10"
            style="white-space: nowrap"
            @change="handleIsSeats"
          ></el-switch>
          <el-button
            type="primary"
            class="common-marginBottomRight10"
            size="mini"
            @click="showCsConfig"
            style="background-color: #1577d2"
            >配置选项</el-button
          >

          <el-button
            type="primary"
            size="mini"
            @click="exportToExcel(2)"
            class="cs-derive"
            >导出统计</el-button
          >
        </div>

        <!-- 客服统计表格 -->
        <el-table
          :data="csCountData"
          v-loading="csLoading"
          border
          max-height="500"
          highlight-current-row
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          ref="experienceInfoTable"
          @sort-change="handleTableSort"
          class="csTable"
        >
          <el-table-column
            :label="item.label"
            :prop="item.columnId"
            :width="item.width"
            :key="index"
            :fixed="index===0"
            show-overflow-tooltip
            sortable="true"
            v-for="(item, index) in columnConfig"
          >
            <template slot-scope="scope">
              <div v-if="item.type === 'number' || item.type === 'String'">
                {{
                  scope.row[item.columnId] === null ||
                  scope.row[item.columnId] === ""
                    ? 0
                    : scope.row[item.columnId]
                }}
              </div>
              <div v-if="item.type === 'rate'">
                {{
                  scope.row[item.columnId] === null ||
                  scope.row[item.columnId] === ""
                    ? 0
                    : scope.row[item.columnId]
                }}
              </div>
              <div v-if="item.type === 'date'">
                {{
                  scope.row[item.columnId] === null ||
                  scope.row[item.columnId] === ""
                    ? 0
                    : scope.row[item.columnId] | dateFormat
                }}
              </div>
            </template>
          </el-table-column>
          <!-- AI分析操作列 -->
          <el-table-column
            label="操作"
            width="120"
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.csname !== '合计' && scope.row.csname !== '小贝'"
                type="primary"
                icon="el-icon-cpu"
                size="mini"
                @click="aiAnalysis(scope.row)"
                >AI分析</el-button
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            property="csname"
            label="坐席名称"
            sortable="custom"
            show-overflow-tooltip
            width="86"
          ></el-table-column>
          <el-table-column
            property="dialogueCount"
            label="对话数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="firstSentenceDuration"
            show-overflow-tooltip
            label="首句时长"
            sortable="custom"
            :sort-method="
              (a, b) => firstSentenceDurationSort(a, b, 'firstSentenceDuration')
            "
          >
            <template slot-scope="scope">
              {{ scope.row.firstSentenceDuration | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            property="firstSentenceDurationAvg"
            show-overflow-tooltip
            label="首句平均时长"
            sortable="custom"
            :sort-method="
              (a, b) =>
                firstSentenceDurationSort(a, b, 'firstSentenceDurationAvg')
            "
          >
            <template slot-scope="scope">
              {{ scope.row.firstSentenceDurationAvg | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            property="firstTimeSecondCount"
            label="超时数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="firstSentenceTimeoutRate"
            label="超时率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuanweiCount"
            label="微信"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuanweiRate"
            label="转微率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuandianCount"
            label="电话"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuandianRate"
            label="转电率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuanqqCount"
            label="QQ"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuanqqRate"
            label="转Q率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuanqianCount"
            label="转潜数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="zhuanqianRate"
            label="转潜率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="localCount"
            label="本地数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="localRate"
            label="本地率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="outRegionCount"
            label="外地数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="outRegionRate"
            label="外地率"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="orderCount"
            label="预约数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            property="orderRate"
            label="预约率"
            sortable="custom"
          >          </el-table-column> -->
        </el-table>
      </el-dialog>
    </div>
    
    <!-- AI分析结果弹窗 -->
    <el-dialog
      title="AI分析结果"
      :visible.sync="aiDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :z-index="99999"
      top="5vh"
      @close="handleDialogClose"
    >
      <template slot="title">
        <span class="el-dialog__title">AI分析结果</span>
      </template>
      <div class="ai-result-content">
        <!-- 分析中状态 -->
        <div v-if="isAnalyzing" class="analyzing-container">
          <div class="analyzing-icon">
            <i class="el-icon-loading"></i>
          </div>
          <div class="analyzing-text">AI正在分析中，请稍候...</div>
          <div class="analyzing-tip">已等待 {{ waitingSeconds }} 秒</div>
          <el-progress 
            :percentage="100" 
            :indeterminate="true"
            :show-text="false"
            class="analyzing-progress"
          ></el-progress>
        </div>
        
        <!-- 分析结果 -->
        <div v-else-if="aiResult" class="ai-analysis-sections">
          <!-- 访客信息 -->
          <div class="analysis-section">
            <h3 class="section-title">访客画像+话术分析</h3>
            <div class="section-content" v-html="formatMarkdown(aiResult.content1)"></div>
          </div>
          
          <!-- 客服回复分析 -->
          <div class="analysis-section">
            <h3 class="section-title">客服回复质量分析</h3>
            <div class="cs-analysis-container">
              <div class="section-content" v-html="formatMarkdown(aiResult.content2)"></div>
              <div class="radar-chart-wrapper">
                <div id="csRadarChart" ref="csRadarChart" class="radar-chart"></div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 无结果 -->
        <div v-else class="no-result">暂无分析结果</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          v-if="isAnalyzing" 
          type="warning" 
          @click="stopAnalysis" 
          size="mini"
        >中断分析</el-button>
        <el-button @click="aiDialogVisible = false; stopPolling();" size="mini">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import cc from './columcomponent.vue'
import Vue from "vue";
import Sortable from "sortablejs";
// import chatDetail from '../chatDetail.vue'
import chatDrawer from "../chatDrawer.vue";
import * as echarts from 'echarts';

export default {
  name: "chatForm",

  components: {
    // chatDetail,
    chatDrawer,
  },

  data() {
    return {
      data: [],
      value: [],
      draggingKey: null,
      filters: 3,
      isShowTb: false,
      isShowConfig: false,
      select: true,
      pagination: true,
      pagenum: 1,
      curpage: 1,
      scrollPage: 1,
      maxScrollPage: 1,
      pagesize: 100,
      searchInput: "",
      showDetail: false,
      cellItem: null,
      ind: 0,
      dateValue: [
        new Date(new Date(new Date().toLocaleDateString()).getTime()),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
      ],
      dateValue2: [
        new Date(new Date(new Date().toLocaleDateString()).getTime()),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
      ],
      //选择旬默认年月
      defaultYear: new Date().getFullYear().toString(),
      defaultMonth: (new Date().getMonth() + 1).toString(),
      //客服选择旬默认年月
      csDefaultYear: new Date().getFullYear().toString(),
      csDefaultMonth: (new Date().getMonth() + 1).toString(),
      onclick: (row) => {
        console.log("onclick row", row);
        this.cellItem = row;
        this.showDetail = true;
        this.ind = row.index;
      },
      activeConfig: {
        type: "textbtn",
        label: "对话记录",
        handler: (scope) => {
          console.log("此数据", scope.row);
          this.cellItem = scope.row;
          this.showDetail = true;
          console.log("showDetail", this.showDetail);
          this.ind = scope.$index;
        },
        width: "100",
      },
      originllcount: 0,
      ddcount: 0,
      llcount: 0,
      wxcount: 0,
      diaRate: 0,
      wxRate: 0,
      zhuanqianBrowseRate: 0,
      originRate: 0,
      oneSentenceCount: 0,
      oneSentenceRate: "",
      threeSentenceCount: 0,
      threeSentenceRate: "",
      tableData: [],
      tbLoading: false,
      config: [],
      switchValue: true,
      sourceValue: "",
      sourceMap: [
        {
          label: "其他",
          value: 0,
        },
        {
          label: "百度",
          value: 1,
        },
        {
          label: "360",
          value: 2,
        },
        {
          label: "搜狗",
          value: 3,
        },
        {
          label: "神马",
          value: 4,
        },
        {
          label: "快手",
          value: 7,
        },
      ],
      searchScopeData: {
        //   [
        //   // {
        //   //   label: "搜索词",
        //   //   value: 0,
        //   // },
        //   // {
        //   //   label: "购买词",
        //   //   value: 1,
        //   // },
        //   // {
        //   //   label: "访客昵称",
        //   //   value: 2,
        //   // },
        //   // {
        //   //   label: "永久身份",
        //   //   value: 3,
        //   // },
        //   // {
        //   //   label: "病种",
        //   //   value: 4,
        //   // },
        // ]
      },
      selectForm: {
        columnsFilter: {},
        keyword: "",
        query: "",
        csid: "",
        page: 1,
        size: 100,
        source: "",
        startTime: "",
        keyrange: "",
        endTime: "",
        region: "",
        aduserId: "",
        columnsSort: {},
        customerStatus: 1,
      },
      csCountData: [],
      showCsCount: false,

      dgTableCountObj: {
        originllcount: "",
        llcount: "",
        ddcount: "",
        wxcount: "",
        diaRate: "",
        wxRate: "",
        zhuanqianBrowseRate: "",
        originRate: "",
        oneSentenceCount: "",
        oneSentenceRate: "",
        threeSentenceCount: "",
        threeSentenceRate: "",
      },
      columnList: [],
      //   2022-9-24 对话统计页面修改
      activeName: "today",
      //数据统计表 选择时间 查询
      showXunSelect: false,
      showTimeSelect: true,
      isDisabled: false,
      xunValue: "",
      //客服统计表 选择时间 查询
      csActiveName: "",
      csCountIsDisabled: false,
      csShowXunSelect: false,
      csShowTimeSelect: true,
      csSwitchValue: true,
      csXunValue: "",
      // 客服科室数据
      csOffice: [],
      officeValue: "",
      csForm: {
        key: "",
        startTime: "",
        endTime: "",
        year: "",
        month: "",
        xun: "",
      },
      csSelectForm: {
        keyword: "",
        page: 1,
        query: "",
        size: 10,
        columnsSort: {},
        csid: "",
        source: 1,
        startTime: "",
        endTime: "",
        region: "",
        aduserId: "",
        customerStatus: 0,
        cs_dep_path: "",
        depType: "",
        allSessionFlag: true,
        columnsFilter: {},
      },
      form: {
        key: "",
        startTime: "",
        endTime: "",
        year: "",
        month: "",
        xun: "",
      },
      // 防抖
      isClick: null,
      leftEl: null,
      rightEl: null,
      // keyrange
      keyrange: "",
      configText: "报表配置选项",
      columnConfig: [],
      csLoading: false,
      
      // 批量打标签相关
      selectedRows: [],
      batchTagDialogVisible: false,
      usedTagList: [],
      allTagList: [],
      isProcessing: false,
      progressPercentage: 0,
      progressStatus: '',
      progressText: '',
      successCount: 0,
      failCount: 0,
      failList: [],
      showResult: false,
      
      // AI分析相关
      aiDialogVisible: false,
      aiResult: null,
      isAnalyzing: false,
      pollingTimer: null,
      pollingCount: 0,
      waitingSeconds: 0,
      waitingTimer: null,
      radarChart: null,
      currentCsid: null, // 当前分析的客服ID

      // 表格展示模式：record 记录模式（默认） / group 分组模式
      tableDisplayMode: "record",
    };
  },

  computed: {
    // 分组模式下按“分组列”排序后的数据；记录模式直接返回原数据
    displayTableData() {
      if (this.tableDisplayMode !== "group" || !this.tableData.length || !this.config.length) {
        return this.tableData;
      }
      const groupProp = this.getGroupByProp();
      if (!groupProp) return this.tableData;
      return this.tableData.slice().sort((a, b) => {
        const va = a[groupProp];
        const vb = b[groupProp];
        if (va === vb) return 0;
        if (va == null || va === "") return 1;
        if (vb == null || vb === "") return -1;
        return String(va).localeCompare(String(vb));
      });
    },
    // 分组模式下用于合并单元格：{ columnIndex: 1, rowSpans: [] }
    groupSpanInfo() {
      if (this.tableDisplayMode !== "group" || !this.displayTableData.length || !this.config.length) {
        return null;
      }
      const groupProp = this.getGroupByProp();
      if (!groupProp) return null;
      const rowSpans = [];
      let i = 0;
      while (i < this.displayTableData.length) {
        const v = this.displayTableData[i][groupProp];
        let count = 0;
        while (i + count < this.displayTableData.length && this.displayTableData[i + count][groupProp] === v) {
          count++;
        }
        rowSpans.push(count);
        for (let j = 1; j < count; j++) rowSpans.push(0);
        i += count;
      }
      const colIdx = this.config.findIndex((c) => c.prop === groupProp);
      const columnIndex = colIdx >= 0 ? 1 + colIdx : 1;
      return { columnIndex, rowSpans };
    },
  },

  created() {
    let startTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime()
    );
    let endTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    );
    this.selectForm.startTime = this.util.dateToTimestamp(startTime);
    this.selectForm.endTime = this.util.dateToTimestamp(endTime);
    this.getSearchScope();
    this.choosedColumnRequest();
  },

  mounted() {
    const transfer = this.$refs.transfer.$el;
    const leftPanel = transfer
      .getElementsByClassName("el-transfer-panel")[0]
      .getElementsByClassName("el-transfer-panel__body")[0];
    const rightPanel = transfer
      .getElementsByClassName("el-transfer-panel")[1]
      .getElementsByClassName("el-transfer-panel__body")[0];
    const rightEl = rightPanel.getElementsByClassName(
      "el-transfer-panel__list"
    )[0];
    const leftEl = leftPanel.getElementsByClassName(
      "el-transfer-panel__list"
    )[0];
    this.leftEl = leftEl;
    this.rightEl = rightEl;
    Sortable.create(rightEl, {
      group: "shared",
      filter: ".no-drag",
      draggable: ".draggable",
      onUpdate: (evt) => {
        const { oldIndex, newIndex } = evt;
        const temp = this.value[oldIndex];
        console.log("onUpdate rightEl  evt", evt, temp);
        this.value.splice(oldIndex, 1);
        this.value.splice(newIndex, 0, temp);
        // if (this.configText !== "报表配置选项") {
        //   const oldValue = this.data[this.value[oldIndex]];
        //   const newValue = this.data[this.value[newIndex]];
        //   console.log(oldValue, newValue);
        // }
        console.log("onUpdate rightEl  value", this.value);
      },
    });

    Sortable.create(leftEl, {
      group: "shared",
      filter: ".no-drag",
      draggable: ".draggable",
      // 元素从一个列表拖拽到另一个列表
      onAdd: (evt) => {
        const { newIndex, to, oldIndex } = evt;
        // 通过获取的文本 得到下标
        const text = to.children[newIndex].children[1].children[0].innerText;
        console.log("onAdd leftEl text:", evt, text, oldIndex);
        if (this.data.length !== 0) {
          const index = this.data.findIndex((item) => {
            return item.label === text;
          });
          console.log("---------index:", index);
          if (index !== -1) {
            this.value.splice(oldIndex, 1);
          } else {
            return;
          }
        }
        console.log("this.value:", this.value);
        this.addClassDraggableAndNoDrag();
      },
      // 元素从列表中移除进入另一个列表
      onRemove: (evt) => {
        const { newIndex, oldIndex } = evt;
        const text = evt.item.innerText;
        console.log("配置选项中 左侧移入右侧数据前：", this.value, this.data);
        const index = this.data.findIndex((item) => item.label === text);
        if (index !== -1) {
          console.log("newIndex oldIndex:", newIndex, oldIndex, text, index);
          this.value.splice(newIndex, 0, index);
          console.log("配置选项中 左侧移入右侧数据后：", this.value);
          this.addClassDraggableAndNoDrag();
        }
      },
    });
    this.handleGetOffice();
    this.csConfig();
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    this.stopPolling();
    // 销毁图表实例
    if (this.radarChart) {
      this.radarChart.dispose();
      this.radarChart = null;
    }
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
  },
  directives: {
    "load-more": {
      bind(el, binding, vnode) {
        console.log("chatForm.vue directives load-more bind");
        const { target } = binding.value;
        const targetEl = el.querySelector(target);
        console.log("chatForm.vue directives load-more el", el);
        const instance = vnode.context;
        let reqFlag = true;
        binding.handler = () => {
          const { scrollTop, scrollHeight, clientHeight } = targetEl;

          // 滚轮临界点(scrollHeight-clientHeight) * 0.75;

          const startScrollReqHig = (scrollHeight - clientHeight) * 0.5;
          if (scrollTop >= startScrollReqHig && scrollTop !== 0) {
            console.log(
              "scrollTop, scrollHeight, clientHeight:",
              scrollTop,
              scrollHeight,
              clientHeight
            );
            // 请求是否需要执行
            if (reqFlag && ++instance.scrollPage <= instance.maxScrollPage) {
              console.log("执行请求 scrollPage", instance.scrollPage);
              reqFlag = false;
              instance.scrollQuest().then(() => {
                console.log("执行请求结束");
                reqFlag = true;
              });
            } else {
              console.log("上次请求未完成，或者已达到可滚动的最大页数");
            }
          } else {
            console.log("chatForm.vue directives 还在滚动");
          }
        };
        targetEl.addEventListener("scroll", binding.handler);
      },
      // inserted(){
      //   console.log("chatForm.vue directives load-more inserted");
      // },
      unbind(el, binding) {
        console.log("chatForm.vue directives load-more unbind");
        const { target } = binding.value;
        const targetEl = el.querySelector(target);
        const handler = binding.handler;
        if (handler) {
          targetEl.removeEventListener(handler);
        }
      },
    },
  },
  methods: {
    // // 宽度方法
    // columnWidth(propItem) {
    //   for (let i = 0; i < this.cs.length; i++) {
    //     if (propItem == this.columnsList[i].columnId) {
    //       return this.columnsList[i].columnWidth;
    //     }
    //   }
    // },
    showCsConfig() {
      this.isShowConfig = true;
      this.configText = "客服统计配置选项";
    },
    async csConfig() {
      const api = "/manager/reporttable/query/listCsStatsiticsTable";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (res.resultCode === "10000") {
        const optionList = res.data;
        this.columnConfig = [];
        this.data = [];
        this.value = [];
        optionList.sort((a, b) => {
          return a.columnSort - b.columnSort;
        });
        for (var i = 0; i < optionList.length; i++) {
          const option = optionList[i];
          const obj = {
            key: i,
            label: `${option.columnName}`,
            columnId: option.columnId,
            userId: option.userId,
            status: option.status,
            width: option.columnWidth,
            sort: option.columnSort,
            type: option.type,
            // disabled: option.isSort === 1 ? false : true,
          };
          if(obj.label.includes('数') == true){
            obj.width = 100;
          }
          if(obj.label.includes('率') == true){
            obj.width = 120;
          }
          this.data.push(obj);
          if (option.status === 1) {
            this.value.push(i);
            this.columnConfig.push(obj);
          }
        }

        this.value.sort;
        this.columnConfig.sort((a, b) => {
          return a.sort - b.sort;
        });
        this.addClassDraggableAndNoDrag();
        console.log(
          "chatForm.vue csConfig this.value",

          this.data,
          this.value,
          this.columnConfig
        );
      } else {
        this.$message.error(res.desc);
      }
    },

    // 滚动查询
    async scrollQuest() {
      const api = "/manager/reporttable/query";
      this.selectForm.page = this.scrollPage;
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selectForm,
      });
      if (res.resultCode === "10000") {
        var dataList = res.data.columnsData;
        for (var j = 0; j < dataList.length; j++) {
          var data = dataList[j];
          if (data.labels !== undefined) {
            if (data.labels.length === 0) {
              const label = {
                name: "暂无",
                color: "",
              };
              data.labels.push(label);
            }
          }
        }
        // for (let i = 0; i < 100; i++) {
        //   this.tableData.push([]);
        // }
        this.tableData.push(...dataList);

        console.log("chatForm.vue scrollQuest  this.tableData", this.tableData);
        // this.pagenum = res.data.total;
      }
    },

    // 获取搜索范围options
    async getSearchScope() {
      var api = "/manager/reporttable/listTableColumns";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      if (response.resultCode === "10000") {
        this.searchScopeData = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
    // 搜索范围
    changeSearchScope() {
      this.selectForm.keyrange = this.keyrange;
    },
    // 表格排序
    handleTableSort(column) {
      console.log("chatForm.vue handleTableSort:", column);
      let orderGroup;
      const sortingType = column.order;
      const fieldName = column.prop;
      let cc = null;
      const sortTypeArr = this.columnConfig.filter((item) => {
        return item.columnId === fieldName;
      });
      const sortType = sortTypeArr[0].type;
      console.log(sortType);
      const mapData = this.csCountData.map((item) => item);
      orderGroup = mapData.filter((item) => {
        if (item.csname === "合计") {
          cc = item;
        }
        return item.csname !== "合计";
      });
      // 降序排序
      let value1 = null;
      let value2 = null;
      if (sortingType == "descending") {
        orderGroup.sort((a, b) => {
          value1 = filterKey(a[fieldName]);
          value2 = filterKey(b[fieldName]);

          // console.log("降序", value1, value2, a, b);
          value1 = parseFloat(value1);
          value2 = parseFloat(value2);

          return value2 - value1;
        });
      } else if (sortingType == "ascending") {
        // 升序排序
        orderGroup.sort((a, b) => {
          value1 = filterKey(a[fieldName]);
          value2 = filterKey(b[fieldName]);
          // console.log("升序", value1, value2, a, b);
          value1 = parseFloat(value1);
          value2 = parseFloat(value2);
          return value1 - value2;
        });
      } else {
        this.$refs.experienceInfoTable.clearSort(); // 清除排序
        return;
      }
      if (cc !== null) {
        orderGroup.push(cc);
      }

      this.csCountData.splice(0, this.csCountData.length, ...orderGroup);
      function filterKey(value) {
        if (value === "/" || value === "" || value === null) {
          value = 0;
        }
        return value;
      }
      // function sortByFirstLetter(items) {
      //   // 将数组拆分为中文和英文数组
      //   const chineseItems = [];
      //   const englishItems = [];
      //   items.forEach((item) => {
      //     // 使用正则表达式判断字符是否是中文
      //     const reg = /^[\u4e00-\u9fa5]+$/;
      //     if (reg.test(item)) {
      //       // 中文字符放入中文数组
      //       chineseItems.push(item);
      //     } else {
      //       // 英文字符放入英文数组
      //       englishItems.push(item);
      //     }
      //   });
      //   // 对中文数组按首字母进行排序
      //   chineseItems.sort((a, b) => {
      //     return a.localeCompare(b, "zh-Hans-CN");
      //   });

      //   // 对英文数组按首字母进行排序
      //   englishItems.sort((a, b) => {
      //     return a.localeCompare(b);
      //   });

      //   // 合并中文和英文数组并返回结果
      //   return chineseItems.concat(englishItems);
      // }
    },
    handleSelectYear(source) {
      if (source === 0) {
        if (this.xunValue !== "") {
          this.handleSelectXun();
        }
      } else {
        if (this.csXunValue !== "") {
          this.csHandleSelectXun();
        }
      }
    },
    handleSelectMonth(source) {
      if (source === 0) {
        if (this.xunValue !== "") {
          this.handleSelectXun();
        }
      } else {
        if (this.csXunValue !== "") {
          this.csHandleSelectXun();
        }
      }
    },
    dragStart(ev, option) {
      console.log("chatForm dragStart ev option = ", ev, option);
      this.draggingKey = option.key;
    },
    // 判断是否为纯数字
    // handleIsNumber(val1, val2, value) {
    //   var reg = /^[1-9][0-9]*$/;
    //   if (!reg.test(value)) {
    //     this.$message.error("内容请输入数字！");
    //     if (val1 === 0) {
    //       console.log(val2, value);
    //       if (val2 === 1) {
    //         this.threeXunIsDisabled1 = true;
    //       } else {
    //         this.threeXunIsDisabled2 = true;
    //       }
    //       this.xunValue = "";
    //     } else {
    //       if (val2 === 1) {
    //         this.csThreeXunIsDisabled1 = true;
    //       } else {
    //         this.csThreeXunIsDisabled2 = true;
    //       }
    //       this.csXunValue = "";
    //     }
    //   } else {
    //     if (val1 === 0) {
    //       if (val2 === 1) {
    //         this.threeXunIsDisabled1 = false;
    //       } else {
    //         this.threeXunIsDisabled2 = false;
    //       }
    //     } else {
    //       if (val2 === 1) {
    //         this.csThreeXunIsDisabled1 = false;
    //       } else {
    //         this.csThreeXunIsDisabled2 = false;
    //       }
    //     }
    //   }
    // },
    // putChange() {
    //   if (this.searchInput.length === 0) {
    //     this.searchInput = "";
    //     this.selectForm.keyword = this.searchInput;
    //     this.statisticsAll();
    //     this.summary();
    //   }
    // },
    // 选择时间段时把结束时间设为当天 23:59:59
    onDateRangeChange(val) {
      if (val && val.length === 2) {
        const end = new Date(val[1]);
        // 仅当结束时间是 00:00:00 时视为“只选了日期”，改为 23:59:59；用户手动改过时间则保留
        const isMidnight =
          end.getHours() === 0 &&
          end.getMinutes() === 0 &&
          end.getSeconds() === 0 &&
          end.getMilliseconds() === 0;
        if (isMidnight) {
          end.setHours(23, 59, 59, 999);
          this.dateValue = [val[0], end.getTime()];
        }
      }
      this.selectDate(999);
    },
    // 通过一段时间得到数据
    selectDate(source) {
      if (source === 999) {
        this.activeName = "";
        if (this.dateValue === null) {
          this.dateValue2 = [];
        } else {
          this.dateValue2.splice(0, 2, this.dateValue[0], this.dateValue[1]);
        }
      }
      if (this.dateValue === null) {
        this.selectForm.startTime = "";
        this.selectForm.endTime = "";
      } else {
        this.selectForm.startTime = (this.dateValue[0] / 1000).toFixed(0);
        this.selectForm.endTime = (this.dateValue[1] / 1000).toFixed(0);
      }
      this.selectForm.page = 1;
      this.scrollPage = 1;
      this.statisticsAll();
      this.summary();
      var dom = this.$refs.dgTable;
      const tempTime = {
        startTime: this.selectForm.startTime,
        endTime: this.selectForm.endTime,
      };
      dom.setSearchConfig(tempTime, 2);
    },

    selectDate2(source) {
      if (source === 999) {
        this.csActiveName = "";
      }
      if (this.dateValue2 === null) {
        this.dateValue2 = [];
        this.csSelectForm.startTime = (
          new Date(new Date().toLocaleDateString()).getTime() / 1000
        ).toFixed(0);
        this.csSelectForm.endTime = (
          (new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1) /
          1000
        ).toFixed(0);
        this.csActiveName = "";
      } else {
        this.csSelectForm.startTime = (this.dateValue2[0] / 1000).toFixed(0);
        this.csSelectForm.endTime = (this.dateValue2[1] / 1000).toFixed(0);
      }
      this.selectByUser();
    },
    closeDialAction() {
      this.showDetail = false;
      this.cellItem = null;
    },

    tagChangeAction(labels) {
      this.$set(this.tableData[this.ind], "labels", labels);
      // if (isSuccess) {
      //   this.queryBySid(this.tableData[this.ind].sid);
      // }
    },
    // async queryBySid(sid) {
    //   const queryBySidApi = "/manager/reporttable/queryBySid";
    //   const response = await this.util.postRequest({
    //     url: queryBySidApi,
    //     method: "POST",
    //     data: {
    //       sid: sid,
    //     },
    //   });
    //   console.log("queryBySid this.tableData[this.ind]:", this.tableData[this.ind]);
    //   console.log("queryBySid response.data.labels:", response.data.labels);
    //   if (response.resultCode === "10000") {
    //     this.$set(this.tableData[this.ind], "labels", response.data.labels);
    //   } else {
    //     this.$message.error(response.desc);
    //   }
    // },

    getpage(page) {
      console.log("getPage", page, this.pagesize);
      this.curpage = page;
      if (page === 1) {
        this.selectForm.page = page;
      } else {
        this.selectForm.page = (page - 1) * this.pagesize + 1;
      }

      this.statisticsAll();

      // let allfilter = {
      // 	filters: this.filters,
      // 	page
      // }
      // let res = dofilter(allfilter)
      // this.tableData = res.tableData
    },

    getsize(size) {
      console.log("chatForm  getSize size:", size);
      this.pagesize = size;
      this.selectForm.size = this.pagesize;

      this.statisticsAll();
    },

    stateChange() {
      if (this.switchValue === true) {
        this.selectForm.customerStatus = 1;
      } else {
        this.selectForm.customerStatus = null;
      }
      this.selectForm.page = 1;
      this.statisticsAll();
      this.summary();
      var dom = this.$refs.dgTable;

      dom.setSearchConfig(this.selectForm.customerStatus, 3);
    },

    sourceChange() {
      this.selectForm.source = this.sourceValue;
      this.statisticsAll();
      this.summary();
      // var dom = this.$refs.dgTable
      // dom.setSearchConfig(this.selectForm.source, 5)
    },

    getDateFilter(val) {
      console.log("chatForm getDateFilter:", val);
      const optionList = val.options;
      var tempList = [];
      for (var i = 0; i < optionList.length; i++) {
        const dateStr = optionList[i];
        tempList.push(this.util.dateToTimestamp(dateStr));
      }

      const keystr = val.key;
      const value = tempList.join(",");

      Vue.set(this.selectForm.columnsFilter, keystr, value);
      this.statisticsAll();
      this.summary();
    },

    getFilter(val) {
      console.log("chatForm getFilter:", val);
      if (val.type === "date") {
        this.selectForm.startTime = this.util.dateToTimestamp(val.date.gt);
        this.selectForm.endTime = this.util.dateToTimestamp(val.date.lt);
      } else {
        this.selectForm.columnsFilter = val;
      }

      this.statisticsAll();

      // let allfilter = {
      // 	filters: val,
      // 	page: 1
      // }
      // this.filters = val
      // let res = dofilter(allfilter)
      // this.tableData = res.tableData
      // this.pagenum = res.pagenum
    },

    deleteFilter(delObj) {
      console.log("chatForm deleteFilter", delObj);
      this.$delete(this.selectForm.columnsFilter, delObj.key);
      this.statisticsAll();
      this.summary(false);
    },

    orderChange(val) {
      const keystr = val.key;
      const value = val.order;
      this.selectForm.page = 1;
      Vue.set(this.selectForm.columnsSort, keystr, value);
      this.statisticsAll();
    },

    getselect(val) {
      console.log("chatForm getselect val = ", val);
    },

    transferChange(to, from, movedKeys) {
      console.log("chatForm.vue transferChange:", to, from, movedKeys);
      // console.log("====transferChange:", this.data);
      // if (from === "right") {
      //   for (const item of  this.movedKeys) {
      //     this.data.splice(item, 0, 1);
      //   }
      // } else if (from === "left") {
      //   this.dataList.splice(to, 0, ...movedKeys);
      // }
      this.addClassDraggableAndNoDrag();
    },

    async choosedColumnRequest() {
      this.config = [];
      this.columnList = [];
      var api = "/manager/reporttable/querySelectedColumns";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (response.resultCode === "10000") {
        var obj = {
          columnAlias: "",
          columnDtype: "XuHao",
          columnExplain: "序号",
          columnId: "order_number",
          columnName: "order_number",
          columnSort:0,
          columnWidth: 80,
          hideStatus: 1,
          isDefault: 1,
          isSelected: 1,
          isSort:0
          };
        this.columnList.push(obj)
        this.columnList = this.columnList.concat(response.data);
        for (var i = 0; i < this.columnList.length; i++) {
          const column = this.columnList[i];

          var isFixed = false;
          if (i === 0 || i === 1) {
            isFixed = true;
          }
          let configObj = null;
          if (column.columnDtype === "List") {
            configObj = {
              prop: column.columnId,
              label: column.columnExplain,
              filterConfig: {
                ftn: column.columnExplain,
                type: "range",
                key: column.columnId,
                unit: "",
              },
              isFixed: isFixed,
              type: "List",
            };
          } else if (column.columnDtype === "boolean") {
            configObj = {
              prop: column.columnId,
              label: column.columnExplain,
              filterConfig: {
                ftn: column.columnExplain,
                type: "range",
                key: column.columnId,
                unit: "unit",
              },
              isFixed: isFixed,
              type: "text",
            };
          } else if (column.columnDtype === "XuHao") {
            configObj = {
              prop: column.columnId,
              label: column.columnExplain,
              filterConfig: {
              },
              isFixed: isFixed,
              type: "text",
            };
          } else {
            configObj = {
              prop: column.columnId,
              label: column.columnExplain,
              filterConfig: {
                ftn: column.columnExplain,
                type: "range",
                key: column.columnId,
                unit: "unit",
              },
              isFixed: isFixed,
              type: "text",
            };
          }
          configObj.showValueList = column.hideStatus;
          this.config.push(configObj);
        }

        this.isShowTb = true;

        this.statisticsAll();
        this.summary();
      } else {
        this.$message.error(response.desc);
      }
    },

    // 报表数据查询
    async statisticsAll() {
      this.tableData = [];
      this.tbLoading = true;
      // 禁用选择时间
      this.isDisabled = true;
      var api = "/manager/reporttable/query";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selectForm,
      });

      var api2 = "/manager/reporttable/global/summary";
      const response2 = await this.util.postRequest({
        url: api2,
        method: "POST",
        data: { ...this.selectForm, type: 1 },
      });
      if (this.switchValue) {
        this.dgTableCountObj.originllcount = response2.data.initialBrowseCount;
        this.dgTableCountObj.llcount = response2.data.browseCount;
        this.dgTableCountObj.ddcount = response2.data.dialogueCount;
        this.dgTableCountObj.wxcount = response2.data.zhuanqianCount;
        this.dgTableCountObj.diaRate = response2.data.dialogueRate;
        this.dgTableCountObj.wxRate = response2.data.zhuanqianRate;
        this.dgTableCountObj.zhuanqianBrowseRate = response2.data.zhuanqianBrowseRate;
        this.dgTableCountObj.originRate = response2.data.initialDialogueRate;
        this.dgTableCountObj.oneSentenceCount = response2.data.oneSentenceCount ?? "";
        this.dgTableCountObj.oneSentenceRate = response2.data.oneSentenceRate ?? "";
        this.dgTableCountObj.threeSentenceCount = response2.data.threeSentenceCount ?? "";
        this.dgTableCountObj.threeSentenceRate = response2.data.threeSentenceRate ?? "";
      }
      if (response.resultCode === "10000") {
        var dataList = response.data.columnsData;
        for (var j = 0; j < dataList.length; j++) {
          var data = dataList[j];
          if (data.labels !== undefined) {
            if (data.labels.length === 0) {
              const label = {
                name: "暂无",
                color: "",
              };
              data.labels.push(label);
            }
          }

          // if (data.is_zhuanqian !== undefined) {
          // 	data.is_zhuanqian = data.is_zhuanqian === false ? '否' : '是'
          // }
        }
        this.tableData = dataList;
        this.pagenum = response.data.total;
        const maxPage = response.data.pages;
        // this.curpage = response.data.current;

        this.scrollPage = response.data.current;
        //  每页滚动的最大页码:
        if (maxPage > this.curpage * 100) {
          this.maxScrollPage = this.curpage * 100;
        } else {
          this.maxScrollPage = maxPage;
        }

        if (!this.switchValue) {
          this.dgTableCountObj.originllcount =
            response.data.summaryData.initialBrowseCount;
          this.dgTableCountObj.llcount = response.data.summaryData.browseCount;
          this.dgTableCountObj.ddcount =
            response.data.summaryData.dialogueCount;
          this.dgTableCountObj.wxcount =
            response.data.summaryData.zhuanqianCount;
          this.dgTableCountObj.diaRate = response.data.summaryData.dialogueRate;
          this.dgTableCountObj.wxRate = response.data.summaryData.zhuanqianRate;
          this.dgTableCountObj.zhuanqianBrowseRate = response.data.summaryData.zhuanqianBrowseRate;
          this.dgTableCountObj.originRate =
            response.data.summaryData.initialDialogueRate;
          this.dgTableCountObj.oneSentenceCount =
            response.data.summaryData.oneSentenceCount ?? "";
          this.dgTableCountObj.oneSentenceRate =
            response.data.summaryData.oneSentenceRate ?? "";
          this.dgTableCountObj.threeSentenceCount =
            response.data.summaryData.threeSentenceCount ?? "";
          this.dgTableCountObj.threeSentenceRate =
            response.data.summaryData.threeSentenceRate ?? "";
        }
        var dom = this.$refs.dgTable;
        dom.setSearchConfig(this.selectForm.keyword, 1);
        const tempTime = {
          startTime: this.selectForm.startTime,
          endTime: this.selectForm.endTime,
        };
        dom.setSearchConfig(tempTime, 2);
        dom.setSearchConfig(this.selectForm.customerStatus, 3);
        dom.setSearchConfig(this.selectForm.columnsFilter, 4);
      } else {
        this.$message.error(response.desc);
      }
      this.tbLoading = false;
      // 拿到数据恢复 按钮
      this.isDisabled = false;
    },

    // 查询全局数据
    async summary() {
      var api = "/manager/reporttable/global/summary";

      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selectForm,
      });

      this.originllcount = response.data.initialBrowseCount;
      this.llcount = response.data.browseCount;
      this.ddcount = response.data.dialogueCount;
      this.wxcount = response.data.zhuanqianCount;
      this.diaRate = response.data.dialogueRate;
      this.wxRate = response.data.zhuanqianRate;
      this.originRate = response.data.initialDialogueRate;
      this.zhuanqianBrowseRate = response.data.zhuanqianBrowseRate;
      this.oneSentenceCount = response.data.oneSentenceCount ?? 0;
      this.oneSentenceRate = response.data.oneSentenceRate ?? "";
      this.threeSentenceCount = response.data.threeSentenceCount ?? 0;
      this.threeSentenceRate = response.data.threeSentenceRate ?? "";
      // const response2 = await this.util.postRequest({
      //   url: api,
      //   method: "POST",
      //   data: { ...this.selectForm, type: 1 },
      // });
      // console.log("chatForm.vue summary res2:", response2);
      // this.dgTableCountObj.originllcount = response2.data.initialBrowseCount;
      // this.dgTableCountObj.llcount = response2.data.browseCount;
      // this.dgTableCountObj.ddcount = response2.data.dialogueCount;
      // this.dgTableCountObj.wxcount = response2.data.zhuanqianCount;
      // this.dgTableCountObj.diaRate = response2.data.dialogueRate;
      // this.dgTableCountObj.wxRate = response2.data.zhuanqianRate;
      // this.dgTableCountObj.originRate = response2.data.initialDialogueRate;
    },

    async statisticsColumn(item) {
      console.log("chatForm.vue statisticsColumn:", item);
      if (item.type === "date") {
        this.selectForm.startTime = item.date.gt;
        this.selectForm.endTime = item.date.lt;
      } else {
        const keystr = item.key;
        const value = item.options;
        Vue.set(this.selectForm.columnsFilter, keystr, value);
      }
      this.selectForm.page = 1;
      this.statisticsAll();
      this.summary(false);
    },

    showCount() {
      this.showCsCount = true;
      this.csConfig();
      if (this.dateValue === null) {
        this.dateValue2.splice(0, 2, []);
        this.csSelectForm.startTime = (
          new Date(new Date().toLocaleDateString()).getTime() / 1000
        ).toFixed(0);
        this.csSelectForm.endTime = (
          (new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1) /
          1000
        ).toFixed(0);
      } else {
        this.dateValue2.splice(0, 2, this.dateValue[0], this.dateValue[1]);
        this.csSelectForm.startTime = (this.dateValue2[0] / 1000).toFixed(0);
        this.csSelectForm.endTime = (this.dateValue2[1] / 1000).toFixed(0);
      }
      switch (this.activeName) {
        case "today":
          this.csActiveName = "csToday";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;
        case "yesterday":
          this.csActiveName = "csYesterday";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;
        case "threedays":
          this.csActiveName = "csThreedays";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;

        case "week":
          this.csActiveName = "csWeek";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;
        case "lastweek":
          this.csActiveName = "csLastweek";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;
        case "mouth":
          this.csActiveName = "csMouth";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;
        case "lastmouth":
          this.csActiveName = "csLastmouth";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
          break;
        case "xun":
          this.csActiveName = "csXun";
          this.csShowXunSelect = true;
          this.csShowTimeSelect = false;
          this.csForm.year = this.csDefaultYear;
          this.csForm.month = this.csDefaultMonth;
          break;
        default:
          this.csActiveName = "";
          this.csShowXunSelect = false;
          this.csShowTimeSelect = true;
      }
      setTimeout(() => {
        var xunEleF = document.getElementsByClassName("  csXunActive")[0];
        if (xunEleF && !this.isDisabled) {
          console.log(this.xunValue);
          var xunEle = xunEleF.getElementsByClassName("el-tabs__item is-top");
          if (this.xunValue === "first") {
            xunEle[0].classList.add("is-active");
          } else if (this.xunValue === "middle") {
            xunEle[1].classList.add("is-active");
          } else if (this.xunValue === "end") {
            xunEle[2].classList.add("is-active");
          }
        }
      });
      this.csSelectForm.allSessionFlag = !this.csSwitchValue;
      this.selectByUser();
      // this.$nextTick(function () {
      //   //获取元素
      //   var xunEle = document.getElementById("csXunActive");
      //   console.log(xunEle);
      // });

      // this.csSelectForm.startTime = (
      //   this.csSelectForm.startTime / 1000
      // ).toFixed(0);
      // this.csSelectForm.endTime = (this.csSelectForm.endTime / 1000).toFixed(0);
      // // if (this.dateValue2 !== "") {
      // //   this.csSelectForm.startTime = (this.dateValue2[0] / 1000).toFixed(0);
      // //   this.csSelectForm.endTime = (this.dateValue2[1] / 1000).toFixed(0);
      // // }
    },
    // 客服报表关闭触发事件
    handleCsHide() {
      this.csXunValue = "";
    },

    async selectByUser() {
      // if (this.csSelectForm.startTime > 0) {
      //   this.csSelectForm.startTime = this.util.timeStampToDate(
      //     this.csSelectForm.startTime * 1000,
      //     this.csSelectForm.startTime,
      //     0
      //   );
      // }
      // if (this.csSelectForm.endTime > 0) {
      //   this.csSelectForm.endTime = this.util.timeStampToDate(this.csSelectForm.endTime * 1000, 0);
      // }
      this.csCountIsDisabled = true;
      let data = this.csSelectForm;
      this.csLoading = true;
      var api = "/manager/reporttable/query/cs/newStatistical";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data,
      });
      this.csLoading = false;
      if (response.resultCode == 10000) {
        this.csCountData = response.data;
      } else {
        this.$message.error(response.desc);
      }
      this.csCountIsDisabled = false;
    },

    searchAll() {
      if (this.searchInput !== "" && this.keyrange === "") {
        this.$message.warning("请先选择搜索范围");
        return;
      }
      this.selectForm.keyword = this.searchInput;
      this.selectForm.page = 1;
      this.statisticsAll();
      this.summary();
      var dom = this.$refs.dgTable;
      dom.setSearchConfig(this.searchInput, 1);
    },

    clearAction() {
      this.searchInput = "";
      this.selectForm.keyword = this.searchInput;
      var dom = this.$refs.dgTable;
      dom.setSearchConfig(this.searchInput, 1);
    },

    resetAction() {
      this.searchInput = "";
      this.sourceValue = "";
      this.keyrange = "";
      this.showXunSelect = false;
      this.showTimeSelect = true;
      this.selectForm.keyword = this.searchInput;
      this.csSwitchValue = true;
      this.dateValue = [
        new Date(new Date(new Date().toLocaleDateString()).getTime()),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
      ];
      this.activeName = "today";
      let startTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      let endTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
      this.selectForm.startTime = this.util.dateToTimestamp(startTime);
      this.selectForm.endTime = this.util.dateToTimestamp(endTime);
      this.selectForm.columnsFilter = {};
      this.selectForm.columnsSort = {};
      this.pagesize = 100;
      this.selectForm.page = 1;
      this.selectForm.size = this.pagesize;
      this.switchValue = true;
      this.selectForm.customerStatus = 1;
      this.selectForm.source = "";
      this.selectForm.keyrange = "";
      this.statisticsAll();
      this.summary();
      var dom = this.$refs.dgTable;
      dom.setSearchConfig(this.searchInput, 1);

      const tempTime = {
        startTime: this.selectForm.startTime,
        endTime: this.selectForm.endTime,
      };
      dom.setSearchConfig(tempTime, 2);

      dom.setSearchConfig(this.selectForm.customerStatus, 3);
      dom.setSearchConfig(this.selectForm.columnsFilter, 4);
      dom.removeAllTags();
  
    },

    clickConfig() {
      console.log("chatForm clickConfig");
      // this.dialogTableVisible = true;
      this.configText = "报表配置选项";
      this.isShowConfig = true;

      this.allOptionRequest();
    },

    headerStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return "text-align:left;padding:5px;color:#fff;background-color:#1577D2";
      } else {
        return "text-align:left;padding:5px;";
      }
    },

    cellStyle() {
      return "text-align:left;padding:0px;";
    },
    async allOptionRequest() {
      this.data = [];
      this.value = [];
      var api = "/manager/reporttable/get/customcolumn/list";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (response.resultCode === "10000") {
        const optionList = response.data;
        console.log("chatForm allOptionRequest 所有得到的数据:", optionList);
        for (var i = 0; i < optionList.length; i++) {
          const option = optionList[i];
          const obj = {
            key: i,
            label: `${option.columnExplain}`,
            item: option,
            // disabled: option.isSort === 1 ? false : true,
          };
          this.data.push(obj);
          if (option.isSelected === 1) {
            this.value.push(i);
          }
          this.value.sort;
        }
        console.log("chatForm allOptionRequest  选中的数据：", this.value);
        this.addClassDraggableAndNoDrag();
      } else {
        this.$message.error(response.desc);
      }
    },
    addClassDraggableAndNoDrag() {
      setTimeout(() => {
        var leftChildren = this.leftEl.children;
        var rightChildren = this.rightEl.children;
        addClass(leftChildren);
        addClass(rightChildren);
      });
      function addClass(element) {
        for (let i = 0; i < element.length; i++) {
          const el = element[i];
          if (el.className.includes("is-disabled")) {
            el.classList.add("no-drag");
          } else {
            el.classList.add("draggable");
            const checkbox = el.children[0];
            checkbox.classList.add("no-drag");
          }
        }
      }
    },
    async saveRequest() {
      this.isShowConfig = false;
      if (this.configText === "报表配置选项") {
        this.updateReportConfig();
      } else {
        this.updateCsReportConfig();
      }
    },
    async updateReportConfig() {
      const iLength = this.value.length;
      var selectItemList = [];
      for (var i = 0; i < iLength; i++) {
        const iVal = this.value[i];
        const obj = this.data[iVal];
        const dataObj = {
          columnId: obj.item.columnId,
          columnSort: i,
        };
        selectItemList.push(dataObj);
      }

      var api = "/manager/reporttable/columnSave";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: selectItemList,
      });
      if (response.resultCode === "10000") {
        console.log("chatForm updateReportConfig data = ", response.data);
        this.isShowTb = false;
        this.choosedColumnRequest();
      } else {
        this.$message.error(response.desc);
      }
    },

    async updateCsReportConfig() {
      let sendObj = [];
      let length = this.value.length;
      this.value.forEach((item, index) => {
        const { userId, columnId } = this.data[item];
        sendObj.push({
          userId,
          columnId,
          columnSort: index + 1,
          status: 1,
        });
      });

      const unselected = this.data.filter((item, index) => {
        const flag = this.value.indexOf(index);
        if (flag === -1) {
          return item;
        }
      });

      unselected.forEach((item) => {
        const { userId, columnId } = item;
        sendObj.push({
          userId,
          columnId,
          columnSort: ++length,
          status: 0,
        });
      });
      console.log("updateCsReportConfig", sendObj, length, unselected);
      var api = "/manager/reporttable/csStatsiticsTable/edit";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: sendObj,
      });
      if (response.resultCode === "10000") {
        console.log("chatForm updateReportConfig data = ", response.data);
        await this.csConfig();
        this.selectByUser();
      } else {
        this.$message.error(response.desc);
      }
    },

    async exportToExcel(i) {
      var api =
        i == 1
          ? "/manager/chatHistory/exportEsToExcel"
          : "/manager/chatHistory/exportCsStatisEsExcel";

      // this.selectForm.page = 1
      // this.selectForm.size = 10000
      let csForm;
      csForm = JSON.parse(JSON.stringify(this.selectForm));
      if (i === 1) {
        csForm = JSON.parse(JSON.stringify(this.selectForm));
      } else {
        csForm = JSON.parse(JSON.stringify(this.csSelectForm));
      }

      csForm.page = 1;
      csForm.size = 10000;
      // const dataObj = {
      // 	page:1,
      // 	size:10000,
      // 	type:1,
      // 	startTime: this.util.timeStampToDate(this.selectForm.startTime*1000, 0),
      // 	endTime: this.util.timeStampToDate(this.selectForm.endTime*1000, 0),
      // 	isSpoken:this.selectForm.customerStatus
      // }

      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: csForm,
        responseType: "arraybuffer",
      });

      let blob = new Blob([response], {
        type: "application/vnd.ms-excel",
      });
      let fileName =
        (i == 1 ? "报表" : "客服统计") + this.util.getFormatDate(3) + ".xls";

      this.downFile(blob, fileName);
    },
    async exportToCsv() {
      var api = "/manager/reporttable/generateCSV";
      this.selectForm.page = 1;
      this.selectForm.size = 50000;

      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selectForm,
        responseType: "arraybuffer",
      });
      console.log("chatForm.vue exportToHtml response:", response);
      this.selectForm.size = this.pagesize;
      let blob = new Blob([response], {
        type: "text/csv",
      });
      let fileName = "会话记录" + this.util.getFormatDate(3) + ".csv";

      this.downFile(blob, fileName);
    },
    async exportToHtml(event) {
      console.log("chatForm exportToHtml e = ", event);

      var api = "/manager/reporttable/generateHtml";
      this.selectForm.page = 1;
      this.selectForm.size = 10000;

      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selectForm,
        responseType: "arraybuffer",
      });

      this.selectForm.size = this.pagesize;
      let blob = new Blob([response], {
        type: "application/vnd.ms-excel",
      });
      let fileName = "会话记录" + this.util.getFormatDate(3) + ".html";
      this.downFile(blob, fileName);
    },

    downFile(blob, fileName) {
      if (this.$nodeFs) {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.addEventListener("loadend", () => {
          const filePath = reader.result;
          const ipc = this.$electron.ipcRenderer;
          ipc.send("downLoad", {
            filePath,
            fileName,
          });
          console.log("electron loadend", fileName);
          console.log("electron loadend", filePath);
        });
      } else {
        console.log("非electron 环境");
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          console.log(fileName);
          window.URL.revokeObjectURL(link.href);
        }
      }
    },
    updateNickname(info) {
      console.log(
        "chatForm updateNickname  customer_nickname",
        this.tableData[this.ind]
      );
      this.tableData[this.ind].customer_nickname = info;
      // this.choosedColumnRequest()
    },
    updateMark(info) {
      console.log(
        "chatForm updateNickname customer_remark",
        this.tableData[this.ind]
      );
      this.tableData[this.ind].customer_remark = info;
    },

    // 自定义排序
    firstSentenceDurationSort(row1, row2, column) {
      // console.log("a,b",a,b)
      let row1_column = row1[column];
      let row2_column = row2[column];
      // console.log('row1_column',row1_column,'row2_column',row2_column)
      if (row1_column > row2_column) {
        return -1;
      } else {
        return 1;
      }
      // return row1_column > row2_column
    },
    // 右键复制整行
    rightClick(row) {
      // console.log("rightClick row",row)
      let copyText = "";
      let labels = "";
      for (let i = 0; i < row.labels.length; i++) {
        labels =
          labels.length == 0
            ? labels + row.labels[i].name
            : labels + "/" + row.labels[i].name;
      }

      for (let j = 0; j < this.config.length; j++) {
        // copyText = copyText.length == 0 ? copyText + row[this.config[j].prop] : copyText + ' ' + row[this.config[j].prop]
        if (copyText.length == 0) {
          copyText =
            this.config[j].prop == "labels"
              ? copyText + labels
              : copyText + row[this.config[j].prop];
        } else {
          copyText =
            this.config[j].prop == "labels"
              ? copyText + "\t" + labels
              : copyText + "\t" + row[this.config[j].prop];
        }
      }
      this.$store.state.copyText = copyText;
      this.$message.success("复制数据成功");
      this.$copyText(copyText).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },

    // 选择上中下旬
    handleSelectXun() {
      if (this.xunValue == "first") {
        this.form.startTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "01" + " 00:00:00";
        this.form.endTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "10" + " 23:59:59";
      } else if (this.xunValue == "middle") {
        this.form.startTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "11" + " 00:00:00";
        this.form.endTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "20" + " 23:59:59";
      } else {
        let length = this.getMonthLength(this.defaultYear, this.defaultMonth);
        this.form.startTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "21" + " 00:00:00";
        this.form.endTime =
          this.defaultYear +
          "-" +
          this.defaultMonth +
          "-" +
          length +
          " 23:59:59";
      }
      this.csDefaultYear = this.defaultYear;
      this.csDefaultMonth = this.defaultMonth;
      this.dateValue.splice(
        0,
        2,
        new Date(this.form.startTime).getTime(),
        new Date(this.form.endTime).getTime()
      );
      this.dateValue2.splice(
        0,
        2,
        new Date(this.form.startTime).getTime(),
        new Date(this.form.endTime).getTime()
      );
      this.selectDate();
    },
    // 选择上中下旬
    csHandleSelectXun() {
      if (this.csXunValue == "first") {
        this.csForm.startTime =
          this.csDefaultYear +
          "-" +
          this.csDefaultMonth +
          "-" +
          "01" +
          " 00:00:00";
        this.csForm.endTime =
          this.csDefaultYear +
          "-" +
          this.csDefaultMonth +
          "-" +
          "10" +
          " 23:59:59";
      } else if (this.csXunValue == "middle") {
        this.csForm.startTime =
          this.csDefaultYear +
          "-" +
          this.csDefaultMonth +
          "-" +
          "11" +
          " 00:00:00";
        this.csForm.endTime =
          this.csDefaultYear +
          "-" +
          this.csDefaultMonth +
          "-" +
          "20" +
          " 23:59:59";
      } else {
        let length = this.getMonthLength(
          this.csDefaultYear,
          this.csDefaultMonth
        );
        this.csForm.startTime =
          this.csDefaultYear +
          "-" +
          this.csDefaultMonth +
          "-" +
          "21" +
          " 00:00:00";
        this.csForm.endTime =
          this.csDefaultYear +
          "-" +
          this.csDefaultMonth +
          "-" +
          length +
          " 23:59:59";
      }
      this.dateValue2.splice(
        0,
        2,
        new Date(this.csForm.startTime).getTime(),
        new Date(this.csForm.endTime).getTime()
      );
      this.selectDate2(
        new Date(this.csForm.startTime).getTime(),
        new Date(this.csForm.endTime).getTime()
      );
    },
    getMonthLength(year, month) {
      return new Date(year, month, 0).getDate();
    },

    handleClick(tab) {
      var name = tab.name;
      var start;
      var end;
      var now = new Date();
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      var nowDay = now.getDate(); //当前日
      this.xunValue = "";
      if (this.dateValue === null) {
        this.dateValue = [];
        console.log(this.dateValue);
      }
      if (nowDayOfWeek === 0) {
        nowDayOfWeek = 7;
      }
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年

      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastMonth = lastMonthDate.getMonth();
      if (name === "today") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start = new Date(new Date().toLocaleDateString()).getTime();
        end =
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1;
        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start, end);
        this.dateValue.splice(0, 2, start, end);
        // this.selectDate(start, end);
        this.selectDate();
      } else if (name === "yesterday") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000;
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start, end);
        this.dateValue.splice(0, 2, start, end);
        this.selectDate();
      } else if (name === "lastweek") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6);
        end = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);

        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        this.dateValue.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate(start.getTime(), end.getTime() - 1000);
        this.selectDate();
      } else if (name === "mouth") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        var monthEndDate = new Date(nowYear, nowMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24); //本月天数
        start = new Date(nowYear, nowMonth, 1);

        end = new Date(nowYear, nowMonth, days + 1);
        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        this.dateValue.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate(start.getTime(), end.getTime() - 1000);
        this.selectDate();
      } else if (name === "lastmouth") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        if (lastMonth === 11) {
          nowYear--;
        }
        var lastMonthStartDate1 = new Date(nowYear, lastMonth, 1);
        var lastMonthEndDate1 = new Date(nowYear, lastMonth + 1, 1);
        var days1 =
          (lastMonthEndDate1 - lastMonthStartDate1) / (1000 * 60 * 60 * 24);
        start = new Date(nowYear, lastMonth, 1);
        console.log("lastMonth:", lastMonth);
        end = new Date(nowYear, lastMonth, days1 + 1);
        console.log("lastMonth start:", start.toLocaleString());
        console.log("lastMonth end:", end.toLocaleString());
        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        this.dateValue.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate(start.getTime(), end.getTime() - 1000);
        this.selectDate();
      } else if (name == "threedays") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          72 * 60 * 60 * 1000;
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start, end);
        this.dateValue.splice(0, 2, start, end);
        // this.selectDate(start, end);
        this.selectDate();
      } else if (name === "week") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        end = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 8);
        // 客服报表和数据报表一致
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        this.dateValue.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate(start.getTime(), end.getTime() - 1000);
        this.selectDate();
      } else if (name === "xun") {
        this.showXunSelect = true;
        this.showTimeSelect = false;
      }
    },
    // 客服报表
    handleCsClick(tab) {
      var name = tab.name;
      var start;
      var end;
      var now = new Date();
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      this.csXunValue = "";
      var nowDay = now.getDate(); //当前日
      if (nowDayOfWeek === 0) {
        nowDayOfWeek = 7;
      }

      if (this.dateValue2 === null) {
        this.dateValue2 = [];
      }
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastMonth = lastMonthDate.getMonth();
      if (name === "csToday") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        start = new Date(new Date().toLocaleDateString()).getTime();
        end =
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1;
        this.csSelectForm.startTime = start;
        this.csSelectForm.endTime = end;
        this.dateValue2.splice(0, 2, start, end);
        // this.selectDate2(start, end);
        this.selectDate2();
      } else if (name === "csYesterday") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000;
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        this.csSelectForm.startTime = start;
        this.csSelectForm.endTime = end;
        this.dateValue2.splice(0, 2, start, end);
        // this.selectDate2(start, end);
        this.selectDate2();
      } else if (name === "csLastweek") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6);
        end = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        this.csSelectForm.startTime = start.getTime() - 1000;
        this.csSelectForm.endTime = end.getTime() - 1000;
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate2(start.getTime(), end.getTime());
        this.selectDate2();
      } else if (name === "csMouth") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        var monthEndDate = new Date(nowYear, nowMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24); //本月天数
        start = new Date(nowYear, nowMonth, 1);
        end = new Date(nowYear, nowMonth, days + 1);
        this.csSelectForm.startTime = start.getTime() - 1000;
        this.csSelectForm.endTime = end.getTime() - 1000;
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate2(start.getTime(), end.getTime() - 1000);
        this.selectDate2();
      } else if (name === "csLastmouth") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        var lastMonthStartDate1 = new Date(nowYear, lastMonth, 1);
        var lastMonthEndDate1 = new Date(nowYear, lastMonth + 1, 1);
        var days1 =
          (lastMonthEndDate1 - lastMonthStartDate1) / (1000 * 60 * 60 * 24);
        if (lastMonth === 11) {
          nowYear--;
        }
        start = new Date(nowYear, lastMonth, 1);
        end = new Date(nowYear, lastMonth, days1 + 1);
        this.csSelectForm.startTime = start.getTime();
        this.csSelectForm.endTime = end.getTime() - 1000;
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate2(start.getTime(), end.getTime() - 1000);
        this.selectDate2();
      } else if (name == "csThreedays") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          72 * 60 * 60 * 1000;
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        this.csSelectForm.startTime = start;
        this.csSelectForm.endTime = end;
        this.dateValue2.splice(0, 2, start, end);
        // this.selectDate2(start, end);
        this.selectDate2();
      } else if (name === "csWeek") {
        this.csShowXunSelect = false;
        this.csShowTimeSelect = true;
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        end = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 8);
        this.csSelectForm.startTime = start.getTime();
        this.csSelectForm.endTime = end.getTime() - 1000;
        this.dateValue2.splice(0, 2, start.getTime(), end.getTime() - 1000);
        // this.selectDate2(start.getTime(), end.getTime() - 1000);
        this.selectDate2();
      } else if (name === "csXun") {
        this.csShowXunSelect = true;
        this.csShowTimeSelect = false;
        this.csForm.year = "";
        this.csForm.month = "";
      }
    },
    // 得到科室列表
    async handleGetOffice() {
      var api = "/manager/departmentType/getDepTypeList";
      var response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: localStorage.getItem("token"),
      });
      if (response.resultCode === "10000") {
        this.csOffice.push(...response.data);
      } else {
        this.$message.error(response.desc);
      }
    },
    // 多科室筛选
    handleCsSelectedOffice(value) {
      this.csSelectForm.depType = value.join(",");
      this.selectByUser();
    },
    // 坐席筛选
    handleIsSeats() {
      this.csSelectForm.allSessionFlag = !this.csSwitchValue;
      console.log("坐席接入：", !this.csSelectForm.allSessionFlag);
      this.selectByUser();
    },
    
    // 分组模式下用于合并的列（取第一个非序号的列）
    getGroupByProp() {
      if (!this.config || !this.config.length) return null;
      const c = this.config.find((col) => col.prop !== "order_number");
      return c ? c.prop : this.config[0].prop;
    },

    // 批量打标签相关方法
    handleSelectionChange(selection) {
      console.log('选择的记录:', selection);
      this.selectedRows = selection;
    },

    // 屏蔽访客：按选中行的 ipv4 调用 addFilterIP，多选则调用多次
    async blockVisitors() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning("请先选择要屏蔽的访客记录");
        return;
      }
      const ips = [];
      for (const row of this.selectedRows) {
        const ip = row.ipv4;
        if (ip !== undefined && ip !== null && String(ip).trim() !== "") {
          ips.push(String(ip).trim());
        }
      }
      if (ips.length === 0) {
        this.$message.warning("所选记录中没有有效的 ipv4，无法屏蔽");
        return;
      }
      const loading = this.$loading({ text: "正在屏蔽访客..." });
      let success = 0;
      let fail = 0;
      try {
        for (const ip of ips) {
          try {
            const res = await this.util.postRequest({
              url: "/manager/reporttable/addFilterIP",
              method: "POST",
              data: { IP: ip },
            });
            if (res && res.resultCode === "10000") {
              success++;
            } else {
              fail++;
            }
          } catch (e) {
            fail++;
          }
        }
        loading.close();
        if (fail === 0) {
          this.$message.success(`已成功屏蔽 ${success} 个访客`);
          this.statisticsAll();
        } else {
          this.$message.warning(`屏蔽完成：成功 ${success} 个，失败 ${fail} 个`);
        }
      } catch (e) {
        loading.close();
        this.$message.error("屏蔽访客失败");
      }
    },

    batchTagDialog() {
      this.batchTagDialogVisible = true;
      this.showResult = false;
      this.isProcessing = false;
      // 不重置选择，因为选择是在主表格中进行的
      this.getBatchTagsRequest();
    },
    
    async getBatchTagsRequest() {
      try {
        // 获取标签列表
        var api = "/manager/labelLnUser/settingSwitchAll";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            cid: this.selectedRows.length > 0 ? this.selectedRows[0].cid : (this.tableData.length > 0 ? this.tableData[0].cid : ""), // 优先使用选中记录的cid
          },
        });
        
        if (response.data !== null) {
          // 重置标签列表
          this.usedTagList = [];
          this.allTagList = [];
          
          // 处理常用标签
          for (var i = 0; i < response.data.labelVoFiveList.length; i++) {
            var used = response.data.labelVoFiveList[i];
            used.selected = false;
            this.usedTagList.push(used);
          }
          
          // 处理所有标签
          for (var j = 0; j < response.data.labelVoAllList.length; j++) {
            var tag = response.data.labelVoAllList[j];
            tag.selected = false;
            this.allTagList.push(tag);
          }
        }
      } catch (error) {
        console.error('获取标签列表失败:', error);
        this.$message.error('获取标签列表失败');
      }
    },
    
    toggleTag(section, index) {
      let isChecked = null;
      if (section === 0) {
        const usedTag = this.usedTagList[index];
        // 同步所有标签列表中的状态
        for (var i = 0; i < this.allTagList.length; i++) {
          var allTag = this.allTagList[i];
          if (usedTag.id === allTag.id) {
            allTag.selected = !allTag.selected;
          }
        }
        usedTag.selected = !usedTag.selected;
        
        // 检查是否有其他标签被选中
        isChecked = this.usedTagList.some((item) => {
          return item.id !== "zanwu" && item.selected === true;
        });
      } else {
        const allTag = this.allTagList[index];
        // 同步常用标签列表中的状态
        for (var j = 0; j < this.usedTagList.length; j++) {
          var usedTag = this.usedTagList[j];
          if (usedTag.id === allTag.id) {
            usedTag.selected = !usedTag.selected;
          }
        }
        allTag.selected = !allTag.selected;
        
        // 检查是否有其他标签被选中
        isChecked = this.allTagList.some((item) => {
          return item.id !== "zanwu" && item.selected === true;
        });
      }
      
      // 处理"暂无"标签的状态
      this.handleZanwuTag(isChecked);
    },
    
    handleZanwuTag(isChecked) {
      // 处理常用标签中的暂无标签
      const usedZanwuIndex = this.usedTagList.findIndex(item => item.id === "zanwu");
      if (usedZanwuIndex !== -1) {
        if (isChecked) {
          this.usedTagList[usedZanwuIndex].selected = false;
        } else {
          this.usedTagList[usedZanwuIndex].selected = true;
        }
      }
      
      // 处理所有标签中的暂无标签
      const allZanwuIndex = this.allTagList.findIndex(item => item.id === "zanwu");
      if (allZanwuIndex !== -1) {
        if (isChecked) {
          this.allTagList[allZanwuIndex].selected = false;
        } else {
          this.allTagList[allZanwuIndex].selected = true;
        }
      }
    },
    
    getSelectedTags() {
      const selectedTags = [];
      
      // 收集选中的标签
      for (var i = 0; i < this.usedTagList.length; i++) {
        const tag = this.usedTagList[i];
        if (tag.selected === true) {
          selectedTags.push(tag);
        }
      }
      
      for (var j = 0; j < this.allTagList.length; j++) {
        const tag = this.allTagList[j];
        if (tag.selected === true) {
          // 避免重复添加
          const exists = selectedTags.some(selectedTag => selectedTag.id === tag.id);
          if (!exists) {
            selectedTags.push(tag);
          }
        }
      }
      
      return selectedTags;
    },
    
    async startBatchTag() {
      const selectedTags = this.getSelectedTags();
      if (selectedTags.length === 0) {
        this.$message.warning('请选择要打的标签');
        return;
      }
      
      this.isProcessing = true;
      this.showResult = false;
      this.progressPercentage = 0;
      this.progressStatus = '';
      this.successCount = 0;
      this.failCount = 0;
      this.failList = [];
      
      const total = this.selectedRows.length;
      
      for (let i = 0; i < this.selectedRows.length; i++) {
        const row = this.selectedRows[i];
        this.progressText = `正在处理第 ${i + 1}/${total} 条记录...`;
        
        try {
          await this.setTagForRow(row, selectedTags);
          this.successCount++;
        } catch (error) {
          this.failCount++;
          this.failList.push({
            customer_nickname: row.customer_nickname,
            createTime: row.createTime,
            errorMsg: error.message || '打标签失败'
          });
        }
        
        // 更新进度
        this.progressPercentage = Math.round(((i + 1) / total) * 100);
        
        // 添加延迟避免请求过于频繁
        if (i < this.selectedRows.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      
      // 完成处理
      this.isProcessing = false;
      this.showResult = true;
      this.progressStatus = this.failCount === 0 ? 'success' : 'warning';
      this.progressText = `处理完成！成功 ${this.successCount} 条，失败 ${this.failCount} 条`;
      
      if (this.failCount === 0) {
        this.$message.success('批量打标签完成！');
      } else {
        this.$message.warning(`批量打标签完成！成功 ${this.successCount} 条，失败 ${this.failCount} 条`);
      }
    },
    
    async setTagForRow(row, selectedTags) {
      const account = JSON.parse(localStorage.getItem("account"));
      
      // 构建标签用户关联数据
      var labelLnUsers = [];
      for (var i = 0; i < selectedTags.length; i++) {
        const tag = selectedTags[i];
        if (tag.id !== "zanwu") {
          labelLnUsers.push({
            userId: account.id,
            lableId: tag.id,
          });
        }
      }
      
      // 如果没有选中任何标签，设置为暂无
      if (labelLnUsers.length === 0) {
        labelLnUsers = [{
          userId: account.id,
          lableId: "zanwu",
        }];
      }
      
      // 调用打标签API
      var api = "/manager/labelLnUser/saveList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          labelLnUsers,
          cid: row.cid,
          sid: row.sid,
          csid: row.csid,
        },
      });
      
      if (response.resultCode !== "10000") {
        throw new Error(response.desc || '打标签失败');
      }
    },
    
    cancelBatchTag() {
      this.batchTagDialogVisible = false;
      this.resetBatchTagState();
    },
    
    closeBatchTagDialog() {
      this.batchTagDialogVisible = false;
      this.resetBatchTagState();
      // 刷新数据
      this.statisticsAll();
    },
    
    resetBatchTagState() {
      this.isProcessing = false;
      this.showResult = false;
      this.progressPercentage = 0;
      this.progressStatus = '';
      this.progressText = '';
      this.successCount = 0;
      this.failCount = 0;
      this.failList = [];
      this.usedTagList = [];
      this.allTagList = [];
      // 不重置selectedRows，因为选择是在主表格中管理的
    },
    
    // 获取默认时间范围（最近一周）
    getDefaultTimeRange() {
      const endTime = new Date();
      endTime.setHours(23, 59, 59, 999);
      const startTime = new Date();
      startTime.setDate(startTime.getDate() - 6); // 最近7天
      startTime.setHours(0, 0, 0, 0);
      
      return {
        startTime: this.formatDateTime(startTime),
        endTime: this.formatDateTime(endTime)
      };
    },
    
    // 格式化日期时间为 "YYYY-MM-DD HH:mm:ss" 格式
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 验证时间范围（最多7天）
    validateTimeRange(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
      return diffDays <= 7;
    },
    
    // AI分析
    async aiAnalysis(row) {
      try {
        const csid = row.csid;
        if (!csid) {
          this.$message.error("无法获取客服ID，请重试");
          return;
        }
        
        this.currentCsid = csid;
        
        // 获取时间范围，优先使用当前选择的时间，如果没有则使用默认时间（最近一周）
        let startTime, endTime;
        if (this.csSelectForm.startTime && this.csSelectForm.endTime) {
          // 将时间戳转换为日期时间字符串
          // 判断时间戳是秒级还是毫秒级：如果小于10000000000（10位数），则为秒级，需要乘以1000
          let startTimestamp = Number(this.csSelectForm.startTime);
          let endTimestamp = Number(this.csSelectForm.endTime);
          
          // 如果时间戳是秒级（小于10000000000），转换为毫秒级
          if (startTimestamp < 10000000000) {
            startTimestamp = startTimestamp * 1000;
          }
          if (endTimestamp < 10000000000) {
            endTimestamp = endTimestamp * 1000;
          }
          
          const start = new Date(startTimestamp);
          const end = new Date(endTimestamp);
          
          // 验证时间范围
          if (!this.validateTimeRange(start, end)) {
            this.$message.warning("时间范围不能超过7天，已自动调整为最近一周");
            const defaultTime = this.getDefaultTimeRange();
            startTime = defaultTime.startTime;
            endTime = defaultTime.endTime;
          } else {
            startTime = this.formatDateTime(start);
            endTime = this.formatDateTime(end);
          }
        } else {
          // 使用默认时间（最近一周）
          const defaultTime = this.getDefaultTimeRange();
          startTime = defaultTime.startTime;
          endTime = defaultTime.endTime;
        }
        
        // 先查询是否已有分析结果
        const checkResponse = await this.util.postRequest({
          url: "/manager/reporttable/csAnalysis",
          method: "POST",
          data: {
            csid: csid,
            startTime: startTime,
            endTime: endTime
          }
        });
        
        if (checkResponse.resultCode == "10000" && checkResponse.data) {
          // 如果有结果，直接显示
          this.aiResult = checkResponse.data;
          this.aiDialogVisible = true;
          // 等待DOM更新后初始化雷达图
          this.$nextTick(() => {
            this.initRadarChart();
          });
        } else {
          // 如果没有结果，先弹窗显示等待状态，然后开启AI分析
          this.isAnalyzing = true;
          this.aiResult = null;
          this.pollingCount = 0;
          this.waitingSeconds = 0;
          this.aiDialogVisible = true;
          // 立即开始计时
          this.startWaitingTimer();
          // 异步开启AI分析
          this.startAIAnalysis(csid, startTime, endTime);
        }
      } catch (error) {
        console.error("AI分析请求失败:", error);
        this.$message.error("网络请求失败，请重试");
      }
    },
    
    // 开启AI分析
    async startAIAnalysis(csid, startTime, endTime) {
      try {
        // 调用开启分析接口（不等待返回，立即开始轮询）
        const startResponse = await this.util.postRequest({
          url: "/manager/reporttable/csAnalysis",
          method: "POST",
          data: {
            csid: csid,
            startTime: startTime,
            endTime: endTime
          }
        });
        
        if (startResponse.resultCode === "10000") {
          // 开启成功，开始轮询获取结果
          this.startPolling(csid, startTime, endTime);
        } else {
          // 开启失败，停止分析状态
          this.isAnalyzing = false;
          this.stopPolling();
          this.$message.error(startResponse.desc || "开启AI分析失败");
        }
      } catch (error) {
        console.error("开启AI分析失败:", error);
        this.isAnalyzing = false;
        this.stopPolling();
        this.$message.error("网络请求失败，请重试");
      }
    },
    
    // 开始等待计时器
    startWaitingTimer() {
      // 清除之前的计时器
      if (this.waitingTimer) {
        clearInterval(this.waitingTimer);
      }
      
      // 如果等待秒数未初始化，则初始化为0
      if (this.waitingSeconds === undefined || this.waitingSeconds === null) {
        this.waitingSeconds = 0;
      }
      
      // 每秒更新等待时间
      this.waitingTimer = setInterval(() => {
        this.waitingSeconds++;
      }, 1000);
    },
    
    // 开始轮询获取AI分析结果
    startPolling(csid, startTime, endTime) {
      // 清除之前的轮询定时器
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
      }
      
      // 如果等待计时器未启动，则启动它（正常情况下已经在aiAnalysis中启动了）
      if (!this.waitingTimer) {
        this.startWaitingTimer();
      }
      
      // 每3秒轮询一次
      this.pollingTimer = setInterval(async () => {
        try {
          this.pollingCount++;
          const response = await this.util.postRequest({
            url: "/manager/reporttable/csAnalysis",
            method: "POST",
            data: {
              csid: csid,
              startTime: startTime,
              endTime: endTime
            }
          });
          
          if (response.resultCode === "10000" && response.data) {
            // 获取到结果，停止轮询
            this.aiResult = response.data;
            this.isAnalyzing = false;
            this.stopPolling();
            // 等待DOM更新后初始化雷达图
            this.$nextTick(() => {
              this.initRadarChart();
            });
          }
        } catch (error) {
          console.error("轮询AI分析结果失败:", error);
          // 继续轮询，不中断
        }
      }, 3000); // 3秒
    },
    
    // 停止轮询
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
      if (this.waitingTimer) {
        clearInterval(this.waitingTimer);
        this.waitingTimer = null;
      }
      this.pollingCount = 0;
      this.waitingSeconds = 0;
    },
    
    // 中断AI分析
    stopAnalysis() {
      this.isAnalyzing = false;
      this.stopPolling();
      this.$message.info("已中断AI分析");
    },
    
    // 对话框关闭时清理
    handleDialogClose() {
      this.aiDialogVisible = false;
      this.stopPolling();
      // 清理图表
      if (this.radarChart) {
        window.removeEventListener('resize', this.handleResize);
      }
    },
    
    // 格式化Markdown
    formatMarkdown(markdown) {
      if (!markdown) return '';
      
      // 简单的Markdown格式化
      let formatted = markdown
        // 处理所有 <b> 相关的标签（包括不完整的标签）
        .replace(/<b[^>]*>([^<]+?)<\/b([：:])/gi, '$1$2')
        .replace(/<b[^>]*>([^<]+?)<\/b>/gi, '$1')
        .replace(/<b[^>]*>/gi, '')
        .replace(/<\/b([：:])/gi, '$1')
        .replace(/<\/b>/gi, '')
        .replace(/<\/b\s*/gi, '')
        .replace(/([^：\s\n])>/g, '$1')
        // 处理粗体 **text** -> <strong>text</strong>
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // 处理斜体 *text* -> <em>text</em>
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        // 处理换行
        .replace(/\n/g, '<br>')
        // 处理分隔线 ---
        .replace(/---/g, '<hr>');
      
      return formatted;
    },
    
    // 解析客服回复分析内容，提取评分维度
    parseCSAnalysis(csReplay) {
      if (!csReplay) return null;
      
      const result = {
        indicators: [],
        values: []
      };
      
      const foundDimensions = [];
      const foundNames = new Set();
      let match;
      
      // 格式1：新格式 - 及时性：说明。   分数：100
      const newFormatPattern = /([^：:\n]+)[：:].*?分数[：:]\s*(\d+)/g;
      
      while ((match = newFormatPattern.exec(csReplay)) !== null) {
        let dimensionText = match[1].trim();
        dimensionText = dimensionText.replace(/<\/b[^>]*/gi, '')
          .replace(/<\/?b[^>]*>/gi, '')
          .replace(/([^：\s\n])>/g, '$1');
        if (dimensionText === '总分数' || dimensionText === '总' || dimensionText.trim() === '') {
          continue;
        }
        const score = parseInt(match[2]);
        
        const cleanDimText = dimensionText.trim();
        if (cleanDimText && !foundNames.has(cleanDimText)) {
          foundNames.add(cleanDimText);
          foundDimensions.push({
            name: cleanDimText,
            value: Math.min(score, 100)
          });
        }
      }
      
      // 格式2：旧格式 - 及时性：95分（说明） 或 专业度：90（说明）
      if (foundDimensions.length === 0) {
        const oldFormatPattern = /([^：:\n（(]+)[：:]\s*(\d+)\s*分?[（(]/g;
        while ((match = oldFormatPattern.exec(csReplay)) !== null) {
          let dimensionText = match[1].trim();
          dimensionText = dimensionText.replace(/<\/?b[^>]*>/gi, '').replace(/<\/b(?=\s|$)/gi, '').trim();
          const score = parseInt(match[2]);
          
          if (dimensionText && !foundNames.has(dimensionText)) {
            foundNames.add(dimensionText);
            foundDimensions.push({
              name: dimensionText,
              value: Math.min(score, 100)
            });
          }
        }
      }
      
      // 如果没有找到维度，使用默认维度
      if (foundDimensions.length === 0) {
        foundDimensions.push(
          { name: '及时性', value: 85 },
          { name: '专业度', value: 90 },
          { name: '友好度', value: 88 },
          { name: '针对性', value: 82 },
          { name: '互动性', value: 80 }
        );
      }
      
      // 构建雷达图数据
      foundDimensions.forEach(dim => {
        result.indicators.push({ name: dim.name, max: 100 });
        result.values.push(dim.value);
      });
      
      return result;
    },
    
    // 初始化雷达图
    initRadarChart() {
      if (!this.aiResult || !this.aiResult.content2) return;
      
      const chartDom = this.$refs.csRadarChart;
      if (!chartDom) return;
      
      // 销毁旧的图表实例
      if (this.radarChart) {
        this.radarChart.dispose();
      }
      
      // 解析数据
      const chartData = this.parseCSAnalysis(this.aiResult.content2);
      if (!chartData || chartData.indicators.length === 0) return;
      
      // 初始化图表
      this.radarChart = echarts.init(chartDom);
      
      const option = {
        title: {
          text: '客服表现评分',
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
            color: '#303133'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            let result = '<div style="padding: 5px;">';
            params.value.forEach((value, index) => {
              result += `${chartData.indicators[index].name}: ${value}分<br/>`;
            });
            result += '</div>';
            return result;
          }
        },
        radar: {
          indicator: chartData.indicators,
          radius: '65%',
          center: ['50%', '55%'],
          splitNumber: 4,
          name: {
            textStyle: {
              color: '#606266',
              fontSize: 12
            }
          },
          splitLine: {
            lineStyle: {
              color: '#e4e7ed'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(64, 158, 255, 0.1)', 'rgba(64, 158, 255, 0.05)']
            }
          },
          axisLine: {
            lineStyle: {
              color: '#e4e7ed'
            }
          }
        },
        series: [{
          type: 'radar',
          data: [{
            value: chartData.values,
            name: '客服评分',
            areaStyle: {
              color: 'rgba(64, 158, 255, 0.3)'
            },
            lineStyle: {
              color: '#409eff',
              width: 2
            },
            itemStyle: {
              color: '#409eff',
              borderColor: '#409eff',
              borderWidth: 2
            }
          }],
          label: {
            show: true,
            formatter: (params) => {
              return params.value;
            },
            color: '#409eff',
            fontSize: 11,
            fontWeight: 'bold'
          }
        }]
      };
      
      this.radarChart.setOption(option);
      
      // 先移除旧的监听器，再添加新的
      window.removeEventListener('resize', this.handleResize);
      window.addEventListener('resize', this.handleResize);
    },
    
    // 处理窗口大小变化
    handleResize() {
      if (this.radarChart) {
        this.radarChart.resize();
      }
    },
  },
};

// function get3MonthBefor() {
//   var resultDate, year, month, date, hms;
//   var currDate = new Date();
//   year = currDate.getFullYear();
//   month = currDate.getMonth() + 1;
//   date = currDate.getDate();
//   hms =
//     currDate.getHours() +
//     ":" +
//     currDate.getMinutes() +
//     ":" +
//     (currDate.getSeconds() < 10
//       ? "0" + currDate.getSeconds()
//       : currDate.getSeconds());
//   console.log(hms);
//   switch (month) {
//     case 1:
//     case 2:
//     case 3:
//       month += 9;
//       year--;
//       break;
//     default:
//       month -= 3;
//       break;
//   }
//   month = month < 10 ? "0" + month : month;
//   resultDate = year + "-" + month + "-" + date + " " + "00:00:00";
//   return resultDate;
// }

// function getMonthBefor() {
//   var resultDate, year, month, date, hms;
//   var currDate = new Date();
//   year = currDate.getFullYear();
//   month = currDate.getMonth() + 1;
//   date = currDate.getDate();
//   hms =
//     currDate.getHours() +
//     ":" +
//     currDate.getMinutes() +
//     ":" +
//     (currDate.getSeconds() < 10
//       ? "0" + currDate.getSeconds()
//       : currDate.getSeconds());
//   console.log(hms);
//   switch (month) {
//     case 1:
//       month += 11;
//       year--;
//       break;
//     // case 2:
//     // case 3:
//     // 	month += 9;
//     // 	year--;
//     // 	break;
//     default:
//       month -= 1;
//       break;
//   }
//   month = month < 10 ? "0" + month : month;
//   resultDate = year + "-" + month + "-" + date + " " + "00:00:00";
//   return resultDate;
// }
</script>

<style scoped="scoped" lang="scss">
/* @import url("//unpkg.com/element-ui@2.15.1/lib/theme-chalk/index.css"); */

.report_container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  background-color: #ffffff;
}

.head_div {
  background-color: #ffffff;
  width: 96%;
  margin: 10px auto;
}

.tb_div {
  width: 96%;
  margin: 0 auto;
  overflow-x: auto;
  /* background-color: yellow; */
  /* height: calc(100%-80px); */
}

.input-with-select {
  max-width: 340px;
  margin-right: 16px;
}

.dialog_div {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000000;
  background-color: rgba(0, 0, 0, 0.5);
}

.title_div {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.25rem;
}

.radio_div {
  width: 18%;
  /* background-color: yellow; */
  display: flex;
  height: 3.75rem;
  align-items: center;
  justify-content: flex-start;
  margin-left: 1.25rem;
}

.radiogp_div {
  display: flex;
}

.back_div {
  width: 50rem;
  height: 30rem;
  background-color: #ffffff;
  margin: 0 auto;
}

.diagBack {
  width: 90%;
  height: 21.25rem;
  background-color: rgba(0, 0, 0, 0.04);
  margin: 0 auto;
  margin-bottom: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.diagBack :deep() .el-transfer-panel {
  width: 15rem;
  /* height: 24.375rem; */
}

.diagBack :deep() .el-transfer-panel__list :deep() .is-filterable {
  height: 400px;
}

/* 汇总专区 */
.summary-zone {
  width: 96%;
  margin: 0 auto 16px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
  z-index: 10;
}
.summary-zone-title {
  padding: 10px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-bottom: 1px solid #e4e7ed;
}
.summary-zone-title-text {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.summary-zone-content {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
}
.summary-part {
  flex: 1;
  min-width: 320px;
  border-right: 1px solid #ebeef5;
}
.summary-part:last-child {
  border-right: none;
}
.summary-part-total .summary-part-header {
  background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%);
  color: #409eff;
}
.summary-part-filter .summary-part-header {
  background: linear-gradient(135deg, #f0f9eb 0%, #e1f3d8 100%);
  color: #67c23a;
}
.summary-part-header {
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
}
.summary-part-body {
  padding: 12px 16px 14px;
}
.summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  margin-bottom: 8px;
}
.summary-row-extra {
  margin-bottom: 0;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
}
.summary-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 100px;
}
.summary-label {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}
.summary-value {
  font-size: 13px;
  font-weight: 500;
  color: #409eff;
}

.count {
  width: 96%;
  background-color: #ffffff;
  margin: 0 auto 10px auto;
}

.count1 {
  /*		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		!* height: 30px; *!
		text-align: center;*/
  float: left;
  margin-right: 20px;
}

.count2 {
  /*display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		!* height: 30px; *!
		text-align: center;
		margin-left: 10px;*/
  float: left;
  margin-right: 20px;
}

.count_span {
  /* height: 100%;	 */
  display: inline-block;
  vertical-align:middle;
  float: right;
  color: #409eff;
  margin: 0 auto;
  line-height: 20px;
}

.common-marginBottomRight10 {
  margin-bottom: 16px;
  margin-right: 10px;
}

.count_span1 {
  /* height: 100%; */
  display: inline-block;
  vertical-align: middle;
  /* color: #409EFF; */
  margin: 0 auto;
  line-height: 20px;
}

.dialog-footer {
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.searchBox {
  width: 96%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  flex-wrap: wrap;
  margin: 22px auto 0px;
  overflow: visible;
  position: relative;
}

.searchBox :deep() {
  .el-tabs__item {
    min-width: 45px;
    height: 28px;
    line-height: 30px;
    padding: 0 10px !important;
    text-align: center;
    @include change_size($font_size_normal);
  }

  .el-tabs__header {
    border-bottom: 1px solid #ffffff !important;
    // width: 228px;
    margin: 0;
  }

  .el-tabs__item.is-active {
    border-bottom-color: #1577d2 !important;
    background-color: #1577d2;
    color: #fff;
  }

  .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }

  .el-tabs,
  .el-tabs--card,
  .el-tabs--top {
    // width: 227px;
    float: left;
  }

  .el-form-item {
    min-width: 0 !important;
  }

  .buttons {
    width: 200px;
  }
}

::v-deep  .csTable {
  th.el-table__cell > .cell {
    white-space: nowrap;
    text-overflow: initial;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
  }
  td.el-table__cell div {
    white-space: nowrap;
    text-align: center;
  }
}

.inputCss :deep() {
  .el-input__inner {
  }

  .el-input--suffix .el-input__inner {
    padding-right: 5px;
  }
}

.customerList {
  max-height: 140px;
  overflow: auto;
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 4px 0px #d3d4de;
  // padding: 5px 10px;
  width: 100%;
}

.date_input :deep() {
  width: 136px !important;

  .el-form-item__content {
    width: 100px;
    margin-right: 10px;
  }
}

.time-text {
  color: #303133;
}

.time-box {
  display: flex;
  align-items: baseline;
  @include change_size($font_size_normal);
}

// 客服统计报表样式
.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}

.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  line-height: 1;
}

// 科室样式
.csOffice {
  min-width: 100px;
  display: block;
}

.cs-derive {
  position: absolute;
  right: 0;
  top: 0;
  background-color: #1577d2;
}

// 选择一段时间 element样式
.el-range-input {
  @include change_size($font_size_normal);
}

::v-deep  .el-transfer-panel__list {
  overflow: hidden auto !important;
  .el-transfer-panel__item.el-checkbox .el-checkbox__label {
    box-sizing: content-box !important;
    padding-left: 0;
  }
}

/* 批量打标签样式 */
.batch-tag-content {
  max-height: 60vh;
  overflow-y: auto;
}

.selected-info {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.selected-count {
  color: #409EFF;
  font-weight: bold;
}

.selected-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.tag-section {
  margin-bottom: 20px;
}

.tag-label {
  font-size: 14px;
  font-weight: bold;
  color: #606266;
  margin-bottom: 10px;
  display: block;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 15px;
}

.tag-item {
  cursor: pointer;
}

.tag-btn, .tag-selected {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #dcdfe6;
  background-color: #f4f7fb;
  color: #606266;
  transition: all 0.3s;
}

.tag-btn:hover {
  background-color: #ecf5ff;
  border-color: #b3d8ff;
}

.tag-selected {
  background-color: #ffffff;
  border-width: 2px;
}

.progress-section {
  text-align: center;
  padding: 20px;
}

.progress-text {
  margin: 15px 0;
  font-size: 14px;
  color: #606266;
}

.progress-details {
  margin-top: 15px;
  font-size: 12px;
  color: #909399;
}

.progress-details p {
  margin: 5px 0;
}

.result-section {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.result-section h4 {
  margin: 0 0 15px 0;
  color: #303133;
}

.result-summary {
  margin-bottom: 15px;
}

.success-text {
  color: #67c23a;
  font-weight: bold;
  margin: 5px 0;
}

.fail-text {
  color: #f56c6c;
  font-weight: bold;
  margin: 5px 0;
}

.fail-details h5 {
  margin: 15px 0 10px 0;
  color: #f56c6c;
}

.common-tags, .all-tags {
  margin-bottom: 20px;
}

/* AI分析相关样式 */
.ai-result-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
  line-height: 1.6;
  color: #333;
}

.no-result {
  text-align: center;
  color: #999;
  font-style: italic;
}

.ai-analysis-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.analysis-section {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}

.section-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
}

.section-content strong {
  color: #303133;
  font-weight: 600;
}

.section-content hr {
  border: none;
  border-top: 1px solid #e4e7ed;
  margin: 15px 0;
}

/* 确保AI分析弹窗在最上层 */
::v-deep  .el-dialog__wrapper {
  z-index: 99999 !important;
}

::v-deep  .v-modal {
  z-index: 99998 !important;
}

/* 分析中状态样式 */
.analyzing-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
}

.analyzing-icon {
  font-size: 48px;
  color: #409eff;
  margin-bottom: 20px;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.analyzing-text {
  font-size: 18px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 10px;
}

.analyzing-tip {
  font-size: 14px;
  color: #909399;
  margin-bottom: 30px;
}

.analyzing-progress {
  width: 300px;
  margin-top: 20px;
}

/* 客服回复分析容器样式 */
.cs-analysis-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
}

.radar-chart-wrapper {
  flex-shrink: 0;
  width: 400px;
  min-width: 400px;
}

.radar-chart {
  width: 100%;
  height: 380px;
  background: #fafafa;
  border-radius: 8px;
  padding: 10px;
}

.cs-analysis-container .section-content {
  flex: 1;
  min-width: 0;
}

/* 响应式布局 */
@media screen and (max-width: 1200px) {
  .cs-analysis-container {
    flex-direction: column;
  }
  
  .radar-chart-wrapper {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }
}

</style>
